import { Router } from "@angular/router";
import { WebView } from "@awesome-cordova-plugins/ionic-webview/ngx";
import { ActionSheetController, AlertController, ModalController, ToastController } from "@ionic/angular";
import { BehaviorSubject, Subject, Subscription } from "rxjs";
import { AuftragService } from "src/app/api/auftrag.service";
import { MyApp } from "src/app/api/helper/app";
import { Logger } from "src/app/api/helper/app-error-logger";
import { AppConfig } from "src/app/api/helper/app.config";
import { AuftragHelper } from "src/app/api/helper/auftrag-helper";
import { ChecklistHelper } from "src/app/api/helper/checklist-helper";
import { UiHelper } from "src/app/api/helper/ui-helper";
import { Utils } from "src/app/api/helper/utils";
import { Auftragsstatus } from "src/app/api/model/aufteagsstatus";
import { AuftragEx, AuftragListItem, AuftragsdateilsDarstellung, AuftragspositionEx, NeutralWorkflowAktuelleAnsichtTyp, StatusmeldungZusatzdaten, UnterschriftInfo, WiegungenZuordnenStatus, WiegungenZuordnenStatusObj } from "src/app/api/model/model";
import { Adresse, ArbeitsartKonfiguration, Artikel, AuftragsFormular, AuftragsKomponente, Auftragsposition, Auftragstyp, Checkliste, Kontakt, MengeOptionTyp, ReCoMobilBild, StatusmeldungZusatzinfo, TextdateiTyp, TourStatusAuftragsdaten, Vertrag, Vertragsposition, Workflow, WorkflowStatus } from "src/app/api/model/swagger-model";
import { RemoteService } from "src/app/api/remote.service";
import { StammdatenService } from "src/app/api/stammdaten.service";
import { SystemService } from "src/app/api/system.service";
import { TourService } from "src/app/api/tour.service";
import { WaageService } from "src/app/api/waage.service";
import { getWaageModusInfo } from "src/app/api/waagen/waage-modus.helper";
import { KontaktlisteComponent } from "src/app/shared/components/kontaktliste/kontaktliste.component";
import { StatuszusatzinfoModalPage } from "src/app/shared/modal/statuszusatzinfo-modal/statuszusatzinfo-modal.page";
import { BildVO, StatusMeldenResult, ButtonVO, PflichtdruckErgebnis, PflichtdruckDruckErgebnis } from "./auftragdetails.model";
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FileHelper } from "src/app/api/helper/file-helper";

import { FileOpener } from "@awesome-cordova-plugins/file-opener/ngx";
import { AuftragLieferungPage } from "../auftrag-lieferung/auftrag-lieferung.page";
import { AuftragBarcodeModalPage } from "src/app/shared/modal/auftrag-barcode-modal/auftrag-barcode-modal.page";
import { AuftragAnmerkungenPage } from "../auftrag-anmerkungen/auftrag-anmerkungen.page";
import { AuftragDruckenPage } from "../auftrag-drucken/auftrag-drucken.page";
import { AuftragBezahlenPage } from "../auftrag-bezahlen/auftrag-bezahlen.page";
import { AuftragAdressePage } from "../auftrag-adresse/auftrag-adresse.page";
import { skip } from "rxjs/operators";
import { AuftragWeiterleitenPage } from "../auftrag-weiterleiten/auftrag-weiterleiten.page";
import { IAuftragdetails } from "./iauftragdetails";
import { AuftragStatusmeldungPage } from "../auftrag-statusmeldung/auftrag-statusmeldung.page";
import { StoerzeitenPage } from "src/app/shared/components/stoerzeiten/stoerzeiten.page";
import { SeriennummernListeComponent } from "src/app/shared/components/seriennummern-liste/seriennummern-liste.component";
import { I18N } from "src/app/api/helper/i18n";
import { ImageHelper } from "src/app/api/helper/image-helper";
import { DruckerHelper } from "src/app/shared/helper/drucker-helper";
import { Zeiterfassung } from "src/app/api/helper/zeiterfassung-helper";

import moment from 'moment';
import { CameraHelper } from "src/app/shared/helper/camera-helper";
import { AuftragArtikelAuswahlPage } from "../artikel-auswahl/artikel-auswahl.component";
import { AuftragspositionWiegenPopupPage } from "../auftragsposition-wiegen-popup/auftragsposition-wiegen-popup.page";

const log = new Logger("AuftragdetailsHelper");

export class Auftragdetails implements IAuftragdetails {
    auftrag: AuftragEx;
    workflow: Workflow;
    formularKonfiguration: AuftragsFormular;
    checklisten: Checkliste[] = [];
    auftragsbilder: BildVO[];
    bilder: BildVO[];
    buttons: ButtonVO[];
    buttons2: ButtonVO[];
    buttons3: ButtonVO[];
    buttonsAuftragPopup: ButtonVO[];
    darstellung: AuftragsdateilsDarstellung;

    lieferungFehlertext = new BehaviorSubject<string>('');
    istLieferungVollstaendig = new BehaviorSubject<boolean>(false);

    leergutFehlertext = new BehaviorSubject<string>('');
    istLeergutVollstaendig = new BehaviorSubject<boolean>(false);

    detectChanges = new Subject<string>();

    auftragspositionFertigChanged = new Subject<AuftragspositionEx>();

    workflowChanged = new Subject<Workflow>();

    beaforePageLeave = new Subject<string>();

    /** Auftrag abgeschlossen */
    auftragAbgeschlossen = new Subject<string>();

    /** Lieferung soll angezeigt werden */
    lieferungAnzeigen = new Subject<string>();

    /** Druck-Dialog soll angezeigt werden */
    druckenAnzeigen = new Subject<WorkflowStatus>();

    /** Bezahlen-Dialog soll angezeigt werden */
    bezahlenAnzeigen = new Subject<WorkflowStatus>();

    /** Anmerkungen-Dialog soll angezeigt werden */
    anmerkungenAnzeigen = new Subject<WorkflowStatus>();

    /** Auftrag weiterleiten-Dialog soll angezeigt werden */
    weiterleitenAnzeigen = new Subject<WorkflowStatus>();

    auftragspositionenGeaendert = new Subject<void>();

    /**  */
    scrollToButtons = new Subject<string>();

    isModalSichtbar = false;
    kameraAktiv = false;
    alertAktiv = false;

    anzeigeBild: BildVO = null;

    subscriptions: Subscription[] = [];

    disposed = false;

    isReadOnly = false;
    istAuftragAbgeschlossen = false;

    isNavigationGesperrt = false;
    isLieferungAendernGesperrt = false;
    isBilderErfassenGesperrt = false;
    isAnmerkungenErfassenGesperrt = false;
    isStatusmeldungGesperrt = false;
    isSchreibgeschuetztAnzeigen = false;
    /** Grund, warum der Auftrag schreibgeschützt ist (für die Anzeige im Banner) */
    schreibschutzGrund = '';
    isUnterschreibenGesperrt = false;
    isHandeingabeErlaubt = false;

    neutralAktuelleAnsicht: NeutralWorkflowAktuelleAnsichtTyp = NeutralWorkflowAktuelleAnsichtTyp.Unbekannt;

    neutralAktuelleGeaendert = new Subject<void>();

    isLieferungAendernGesperrtChanged = new Subject<boolean>();

    constructor(
        private webView: WebView,
        private toastController: ToastController,
        private router: Router,
        private modalController: ModalController,
        private actionSheetController: ActionSheetController,
        private file: File,
        private fileOpener: FileOpener,
        private alertController: AlertController,
        private stammdatenService: StammdatenService,
    ) {

        this.subscriptions.push(this.stammdatenService.workflows.pipe(skip(1)).subscribe((workflows) => this.onWorkflowsChanged(workflows)));
    }

    get auftragService(): AuftragService { return AuftragService.instance; };

    async init(): Promise<void> {
        log?.debug('init');

        this.updateAuftragReadOnly();
        this.updateAuftragAbgeschlossen();
        this.updateNeutralAktuelleAnsicht();
        this.updateHandeingabeErlaubt();

        await this.updateBilder();
        await this.updateAuftragsbilder();
        await this.ladeChecklisten();

        this.initButtons();
        this.updateLieferungVollstaendig('init');
        this.updateLeergutVollstaendig('init');
    }

    dispose() {
        log?.debug('dispose');
        this.disposed = true;
        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];
    }

    async onWorkflowsChanged(workflows: Workflow[]) {
        log?.debug('onWorkflowsChanged');

        if (this.workflow && workflows) {
            const newWorkflow = workflows.find(p => p.name === this.workflow.name);

            if (newWorkflow) {
                this.workflow = newWorkflow;

                this.formularKonfiguration = await this.stammdatenService.getAuftragsFormularKonfiguration(this.auftrag);

                this.workflowChanged.next(newWorkflow);
                this.detectChanges.next('onWorkflowsChanged');
            }
        }
    }

    async updateBilder(): Promise<void> {
        log?.debug('updateBilder');

        const auftrag = this.auftrag;
        const voList = [];

        if (auftrag.Bilder) {
            for (const bild of auftrag.Bilder) {
                const vo = await this.createBildVo(bild);
                voList.push(vo);
            }
        }

        this.bilder = voList;
    }

    async updateAuftragsbilder(): Promise<void> {
        log?.debug('updateAuftragsbilder');

        const auftrag = this.auftrag;
        const auftragsbilderVoList = [];

        const auftragBilder = await AuftragService.instance.getAuftragsBilder(auftrag);

        for (const bild of auftragBilder) {
            const vo = await this.createBildVo(bild);
            auftragsbilderVoList.push(vo);
        }

        log?.debug('auftragsbilder', auftragsbilderVoList);

        this.auftragsbilder = auftragsbilderVoList;
    }

    async createBildVo(bild: ReCoMobilBild): Promise<BildVO> {
        let src = bild.Bild;

        if (!src) {
            src = await AuftragService.instance.getBildSrc(bild.BildGuid);
        }

        if (src && src.startsWith('file:')) {
            // Bild ist als Datei gespeichert und es wird hier der Pfad zurückgegeben
            src = this.webView.convertFileSrc(src);
        } else {
            // Bild ist als Base64 hinterlegt
            if (!src.startsWith("data:image/")) {
                src = 'data:image/jpeg;base64,' + src;
            }
        }

        return {
            src,
            guid: bild.BildGuid,
            datum: '',
            nummer: 0,
            bezeichnung: bild.Bezeichnung
        };
    }

    showAuftragNichtZugewiesen() {
        UiHelper.showAlert('Bitte erst Auftrag diesem Gerät zuweisen.');
    }

    showAuftragArchiviert() {
        UiHelper.showAlert('Auftrag ist bereits archiviert und kann nicht mehr geändert werden');
    }

    showAuftragSchreibgeschuetzt() {
        UiHelper.showAlert('Auftrag ist schreibgeschützt und kann nicht geändert werden');
    }

    updateAuftragAbgeschlossen() {
        this.istAuftragAbgeschlossen = this.auftrag && this.auftrag.Auftragsstatus >= Auftragsstatus.Abgeschlossen;
    }

    async statusMelden(status: WorkflowStatus, mitRueckfrage: boolean): Promise<StatusMeldenResult> {
        log?.debug('statusMelden: ' + status.name, status);

        // Ein Auftrag soll auch abgelehnt werden können ohne die Zeiterfassung zu starten
        if (status.auftragsstatus !== Auftragsstatus.Abgelehnt) {
            if (!await this.pruefeZeiterfassungGestartet()) {
                return;
            }
        }

        const auftrag = this.auftrag;
        const checklisten = this.checklisten;
        const workflow = this.workflow;

        const result: StatusMeldenResult = {
            erfolgreich: false,
            detectChanges: false,
            abbruch: true
        };

        this.updateAuftragReadOnly();
        this.updateAuftragAbgeschlossen();

        let schreibgeschuetztPruefen = true;
        let tourStartErforderlich = true;

        if (status.auftragsstatus == Auftragsstatus.Weiterleiten || status.auftragsstatus == Auftragsstatus.Angenommen || status.auftragsstatus == Auftragsstatus.Abgelehnt) {
            schreibgeschuetztPruefen = false;
            tourStartErforderlich = false;
        }

        if (status.NachAbschlussErlaubt) {
            if (!this.istAuftragAbgeschlossen && this.isStatusmeldungGesperrt && schreibgeschuetztPruefen) {
                this.showAuftragSchreibgeschuetzt();
                return result;
            }
        } else {
            if (this.istAuftragAbgeschlossen) {
                this.showAuftragArchiviert();
                return result;
            }

            if (this.isReadOnly && schreibgeschuetztPruefen) {
                this.showAuftragSchreibgeschuetzt();
                return result;
            }
        }

        if (await this.preufeAuftragNichtZugewiesen(auftrag)) {
            return result;
        }

        // Prüfe ob der Statusübergang erlaubt ist
        // Hier wird geprüft ob z.B. von INITIAL nach ABGESCHLOSSEN erlaubt ist.
        const erlaubt = AuftragService.instance.istStatusuebergangErlaubt(auftrag, workflow, status);

        if (!erlaubt) {
            // Statusübergang ist nicht erlaubt.
            // Zeige eine Fehlermeldung mit den erlaubten Statusmeldungen.
            const erlaubteStatusMeldungen = AuftragService.instance.getAktuellErlaubteStatusMeldungen(auftrag, workflow);

            UiHelper.showAlert(I18N.instant('Meldung430') + ': \n' + erlaubteStatusMeldungen.map(p => p.name).join(', '));
            return result;
        }

        if (!MyApp.current.tourGestartet.getValue() && MyApp.current.tourStartenErforderlich.getValue()) {
            if (auftrag.Auftragstyp == Auftragstyp.Transportauftrag && tourStartErforderlich) {
                const ok = await UiHelper.confirmJaNein(`Meldung429`, 'Tour start');

                if (ok) {
                    await this.router.navigateByUrl('/tour/start');
                }

                return result;
            }
        }

        const aktuelleTour = MyApp.current.aktuelleTour.getValue();

        if (aktuelleTour && auftrag.Auftragstyp === Auftragstyp.Transportauftrag) {
            if (aktuelleTour.ErstwiegungErfolgt || aktuelleTour.ZweitwiegungErfolgt) {
                await UiHelper.showError(`Statusmeldung428`, 'Tour');
                return result;
            }
        }

        if (status.unterschriftErforderlich) {
            // Workflow erfordert, dass alle erforderlichen Unterschriften vorhanden sind
            const fehlertext = this.pruefeUnterschriftenVollstaendig();

            if (fehlertext) {
                UiHelper.showAlert(fehlertext, status.name);
                return result;
            }
        }

        let minAnzahlBilder = status.minAnzahlBilder;

        if (minAnzahlBilder == null) {
            minAnzahlBilder = 0;
        }

        let bilderPositionsText = '';

        // Prüfe die Auftragsposition ob dort eine Mindestanzahl an Bildern vorgegeben ist
        // Die Bilder sind nicht erforderlich, wenn alle Mengen auf 0 gesetzt werden.
        // Die Mengen werden allerdings erst später auf 0 gesetzt, wenn alle wichtigen Prüfungen durchgeführt wurden.
        if (status.auftragsstatus === Auftragsstatus.Abgeschlossen && this.auftrag.Positionen && !status.AlleMengenAufNull) {
            const positionsTexte: string[] = [];

            let minAnzahlAusAuftragspositionen = 0;
            const aufsummieren = AppConfig.current.einstellungen.MinAnzahlBilderInAuftragspositionenAddieren === 'ja';

            const alleArtikel = StammdatenService.instance.getAlleArtikel().getValue();

            for (const position of this.auftrag.Positionen) {
                if (position.Menge) {
                    let positionMinAnzahlBilder = 0;

                    if (typeof (position.MinAnzahlBilder) === 'number') {
                        if (position.MinAnzahlBilder > 0) {
                            positionsTexte.push(position.Bezeichnung + ': ' + position.MinAnzahlBilder);
                        }

                        positionMinAnzahlBilder = position.MinAnzahlBilder;
                    } else {
                        // Prüfe ob der Artikel bekannt ist und ob dort eine Mindestanzahl hinterlegt ist
                        if (position.ArtikelKey) {
                            const artikel = alleArtikel.find(p => p.artikelKey && p.artikelKey as any == position.ArtikelKey);

                            if (artikel) {
                                if (artikel.MinAnzahlBilder) {
                                    positionsTexte.push(position.Bezeichnung + ': ' + artikel.MinAnzahlBilder);
                                    positionMinAnzahlBilder = artikel.MinAnzahlBilder;
                                }
                            }
                        }
                    }

                    if (positionMinAnzahlBilder) {
                        if (aufsummieren) {
                            minAnzahlAusAuftragspositionen += positionMinAnzahlBilder;
                        } else {
                            minAnzahlAusAuftragspositionen = Math.max(positionMinAnzahlBilder, minAnzahlAusAuftragspositionen);
                        }
                    }
                }

                if (positionsTexte.length) {
                    bilderPositionsText = '\n\n' + positionsTexte.join(', \n');
                }
            }

            if (minAnzahlBilder < minAnzahlAusAuftragspositionen) {
                minAnzahlBilder = minAnzahlAusAuftragspositionen;
            }
        }

        // Prüfe ob in den Einstellungen eine Mindestanzahl konfiguriert ist, falls Mengen geändert wurden.
        // Wenn es sich um eine Leerfahrt handelt (Alle Mengen auf 0), dann sind keine Bilder erforderlich.
        if (auftrag.Auftragstyp === Auftragstyp.Transportauftrag && status.bilderSenden && !status.AlleMengenAufNull) {
            const minAnzahlBeiMengenaenderung = Utils.parseInt(AppConfig.current.einstellungen.TransportauftragMinAnzahlBilderBeiMengenaenderung);

            if (minAnzahlBeiMengenaenderung > 0 && minAnzahlBilder < minAnzahlBeiMengenaenderung) {
                for (const position of this.auftrag.Positionen) {
                    if (position.Menge != position.MengeSoll) {
                        log?.debug(`Menge wurde geändert ${this.auftrag.Auftragsnummer} Pos. ${position.PosNr} ${position.Bezeichnung}: soll=${position.MengeSoll}, ist=${position.Menge} ${position.Einheit}`);

                        // Prüfe ob die Einheit auch relevant ist
                        let filterEinheiten = AppConfig.current.einstellungen.TransportauftragMinAnzahlBilderEinheiten;
                        let positionRelevant = true;

                        if (filterEinheiten && filterEinheiten !== '*' && filterEinheiten.trim().length > 0) {
                            // Prüfe ob diese Mengenänderung wirklich relevant ist.
                            // Dafür muss die Einheit noch geprüft werden. Sie ist nur dann relevant, wenn die Einheit explizit angegeben ist
                            positionRelevant = false;

                            filterEinheiten = Utils.trimToEmpty(filterEinheiten).toLowerCase();

                            let einheiten = filterEinheiten.split(',');

                            for (const einheit of einheiten) {
                                let istEinheit = Utils.trimToEmpty(position.Einheit).toLowerCase();

                                if (istEinheit === einheit) {
                                    // Ja, Einheit ist relevant
                                    positionRelevant = true;
                                    break;
                                }
                            }
                        }

                        if (positionRelevant) {
                            if (minAnzahlBilder < minAnzahlBeiMengenaenderung) {
                                minAnzahlBilder = minAnzahlBeiMengenaenderung;
                                break;
                            }
                        }
                    }
                }
            }
        }

        if (auftrag.Auftragstyp === Auftragstyp.Kommissionierung && this.auftrag.Positionen) {
            if (status.auftragsstatus === Auftragsstatus.Abgeschlossen) {
                // Alle Positionen sollen abgehakt worden sein
                if (this.auftrag.Positionen.some(p => !p.Fertig)) {
                    const ok = await UiHelper.confirmJaNein(`Meldung431`, 'Achtung');

                    if (!ok) {
                        return result;
                    }
                }
            }

            if (status.auftragsstatus === Auftragsstatus.Abgelehnt) {
                // Palette wird als Vollpalette gemeldet.
                // if (this.auftrag.Positionen.some(p => p.Fertig)) {
                //     const ok = await UiHelper.confirmJaNein(`Es wurden nicht alle Positionen fertig gemeldet. Palette wirklich fertig melden?`, 'Achtung');

                //     if (!ok) {
                //         return result;
                //     }
                // }
            }
        }

        if (status.auftragsdatenSenden) {
            // Prüfe ob alle Bemerkungen für die Auftragszeiterfassungen eingegeben wurden, falls diese als Pflicht konfiguriert sind.
            let ok = await this.pruefeZeiterfassungVollstaendig();

            if (!ok) {
                return result;
            }
        }

        let undoActions: (() => void)[] = [];

        // Rollback-Funktion. Muss vor jedem Return aufgerufen werden, wenn abgebrochen wird wegen einer Fehlermeldung oder Rückfrage.
        let rollback = (): StatusMeldenResult => {
            undoActions.forEach(action => action());

            return result;
        }

        let oldAuftragspositionen: AuftragspositionEx[] = null;

        if (status.AlleMengenAufNull) {
            // Mit dieser Statusmeldung sollen alle Mengen auf 0 gesetzt werden.
            // Das wird bei Hubert Schmid für den Status "Leerfahrt" verwendet.
            // Es sollen dann keine Bilder für die Container gemacht werden müssen.
            // Aber ACHTUNG: Wenn es nachträglich noch zu Fehlermeldungen kommt, dann müssen die Mengen wieder zurückgesetzt werden.

            // Merke die alten Auftragspositionen
            oldAuftragspositionen = Utils.cloneObj(auftrag.Positionen);

            // Setze alle Mengen auf 0
            // Das soll unabhängig davon gemacht werden, ob die MengeOption eventuell auf nicht änderbar steht.
            // Bei Hubert Schmid haben die Fahrer kein Recht die Menge zu ändern. Mit dem Status-Button soll es trotzdem gehen. 
            for (const position of auftrag.Positionen) {
                position.Menge = 0;
                position.MengeIst = 0;

                // TODO: Klären ob das auch auf 0 gesetzt werden soll.
                position.GewichtInKg = 0;

                // Mengenoption muss auf änderbar geändert werden. Ansonsten knallt es in der Methode pruefeAuftragspositionenVollstaendig()
                position.MengeOption = MengeOptionTyp.Aenderbar;

                // Die "Elemente" auch zurücksetzen. Das wird in updateSeriennummern(vo) so gemacht.
                position.Elemente = [];

                // Behälter müssen auch auf eine leere Liste gesetzt werden. Ansonsten meckert die Prüfung bei pruefeAuftragspositionenVollstaendig() -> 
                position.Behaelter = [];
            }

            undoActions.push(() => {
                // Setze die Auftragspositionen zurück auf ihre ursprünglichen Werte
                auftrag.Positionen = oldAuftragspositionen;
            });
        }

        let meldungAnzahlBilder = '';

        if (status.auftragsstatus === Auftragsstatus.Abgeschlossen) {
            const aktiveRegeln = AuftragHelper.getZutreffendeRegeln(this.auftrag);

            for (const regel of aktiveRegeln) {
                if (regel.Aktion?.MinAnzahlBilderAktiv && regel.Aktion.MinAnzahlBilder != null) {
                    minAnzahlBilder = regel.Aktion.MinAnzahlBilder;
                    meldungAnzahlBilder = regel.Aktion.MinAnzahlBilderMeldung;
                }
            }
        }

        const anzahlFotos = this.auftrag.Auftragsbilder.length;

        if (anzahlFotos < minAnzahlBilder) {
            if (meldungAnzahlBilder) {
                // Es ist über die Regel ein Text definiert der angezeigt werden soll
                UiHelper.showAlert(meldungAnzahlBilder);
            } else if (minAnzahlBilder == 1) {
                UiHelper.showAlert('Es muss mindestens ein Foto gemacht werden!' + bilderPositionsText);
            } else {
                UiHelper.showAlert(`Es müssen mindestens ${minAnzahlBilder} Fotos gemacht werden!` + bilderPositionsText);
            }

            return rollback();
        }

        // Prüfe ob für alle "nicht gescannten" Container ein Foto gemacht wurde.
        // Für Huber & Sohn sollen die Container eigentlich imemr gescannt werden.
        // Wenn sie nicht gescannt wurden, muss für jeden container mindestens ein Foto gemacht werden.
        if (status.BehaelterNummerHandeingabeFotoErforderlich) {
            let nichtGescannteBehaelterNummern: string[] = [];

            for (const position of this.auftrag.Positionen) {
                if (position.Behaelter?.length > 0) {
                    for (const behaelter of position.Behaelter) {
                        if (behaelter.BehaelterNr && !behaelter.IsScan) {
                            nichtGescannteBehaelterNummern.push(behaelter.BehaelterNr);
                        }
                    }
                }
            }

            if (nichtGescannteBehaelterNummern.length > anzahlFotos) {
                const anzahlDifferenz = nichtGescannteBehaelterNummern.length - anzahlFotos;
                const str = Utils.joinNotEmpties('\n', ...nichtGescannteBehaelterNummern);

                const header = anzahlDifferenz + ' Behälter fotografieren';

                if (anzahlDifferenz === 1) {
                    if (nichtGescannteBehaelterNummern.length === 1) {
                        UiHelper.showAlert(`Es wurden nicht alle Behälter gescannt. Bitte fotografieren Sie den Behälter: \n\n` + str, header);
                    } else {
                        UiHelper.showAlert(`Es wurden nicht alle Behälter gescannt!\nEs ist noch ein weiteres Foto erforderlich. Bitte fotografieren Sie alle Behälter: \n\n` + str, header);
                    }
                } else {
                    UiHelper.showAlert(`Es wurden nicht alle Behälter gescannt!\nEs sind noch ${anzahlDifferenz} weitere Fotos erforderlich. Bitte fotografieren Sie die Behälter: \n\n` + str, header);
                }

                return rollback();
            }
        }

        if (status.anmerkungErforderlich) {
            if (!auftrag.Anmerkungen) {
                await UiHelper.showAlert('Bitte Anmerkungen eingeben', null, true);
                this.anmerkungenAnzeigen.next(status);

                return rollback();
            }
        }

        if (status.auftragsstatus == Auftragsstatus.Abgeschlossen) {
            // Prüfe of Checklisten ausgefüllt wurden
            let fehlertext = await this.pruefeChecklistenVollstaendig();

            if (fehlertext) {
                UiHelper.showAlert('Bitte Checklisten vollständig ausfüllen: ' + fehlertext);
                return rollback();
            }

            // Prüfe Positionen vollständig
            fehlertext = this.pruefeAuftragspositionenVollstaendig();

            if (fehlertext) {
                UiHelper.showAlert('Bitte Auftragspositionen vollständig ausfüllen. ' + fehlertext);
                this.lieferungAnzeigen.next('');
                return rollback();
            }

            if (MyApp.current.waageVerfuegbar.getValue()) {
                const anzahlWiegedaten = WaageService.instance.wiegedaten.getValue().length;

                // TODO: Konfiguration einbauen ob eine Zuordnung überhaupt erlaubt ist.
                // Bei THEURL hat das zu Problemen geführt. Hier darf nur direkt verwogen werden. Zuordnen geht nicht.

                if (anzahlWiegedaten > 0) {
                    const config = AppConfig.current.einstellungen.WaageAuftragAbschliessenMitOffnenWiegungen;

                    if (config == 'fehler') {
                        const confirmResult = await UiHelper.confirm(
                            'Es wurden nicht alle Wiegungen zugeordnet. Bitte zuordnen oder löschen.',
                            'Wiegungen',
                            'Löschen',
                            'Zuordnen');

                        switch (confirmResult) {
                            case 'Zuordnen':
                                this.lieferungAnzeigen.next('');
                                break;
                            case 'Löschen':
                                this.router.navigateByUrl('/einstellungen/waage');
                                break;
                        }

                        return rollback();
                    } else if (config == 'warnung') {
                        const confirmResult = await UiHelper.confirmJaNein('Es wurden nicht alle Wiegungen zugeordnet. Auftrag wirklich abschließen?');

                        if (!confirmResult) {
                            return rollback();
                        }
                    }
                }

                // Für Energor soll auch geprüft werden ob die richtige Anzahl an Wiegungen zugeordnet wurde.
                const wiegungenPruefen = AppConfig.current.einstellungen.AuftragWiegungenZuordnenPruefen;

                if (wiegungenPruefen === 'fehler' || wiegungenPruefen === 'warnung') {
                    const obj = this.getWiegungenZuordnenStatusObj();
                    let meldung = '';

                    if (obj.status === 'nicht-zugeordnet') {
                        meldung = 'Es wurden keine Wiegungen zugeordnet.';
                    } else if (obj.status === 'teilweise-zugeordnet') {
                        if (obj.differenz === 1) {
                            meldung = `Es wurden zu wenige Wiegungen zugeordnet. Es fehlt 1 Wiegung.`;
                        } else {
                            meldung = `Es wurden zu wenige Wiegungen zugeordnet. Es fehlen ${obj.differenz} Wiegungen.`;
                        }
                    } else if (obj.status === 'ueber-zugeordnet') {
                        if (-obj.differenz === 1) {
                            meldung = `Es wurden zu viele Wiegungen zugeordnet. Es ist 1 Wiegung zu viel.`;
                        } else {
                            meldung = `Es wurden zu viele Wiegungen zugeordnet. Es sind ${-obj.differenz} Wiegungen zu viel.`;
                        }
                    }

                    if (meldung) {
                        if (wiegungenPruefen === 'fehler') {
                            await UiHelper.showAlert(meldung, 'Wiegungen zuordnen', true);
                            return rollback();
                        } else if (wiegungenPruefen === 'warnung') {
                            const confirmResult = await UiHelper.confirmJaNein(`${meldung} Auftrag wirklich abschließen?`);

                            if (!confirmResult) {
                                return rollback();
                            }
                        }
                    }
                }
            }
        }

        result.abbruch = false;

        if (status.auftragsstatus == Auftragsstatus.Gedruckt) {
            this.druckenAnzeigen.next(status);
            result.abbruch = false;

            // Hier wird abgebrochen. Alles weitere wird von der AuftragDruckenPage gemacht
            return result;
        }

        if (status.auftragsstatus == Auftragsstatus.Bezahlt) {
            this.bezahlenAnzeigen.next(status);
            result.abbruch = false;

            // Hier wird abgebrochen. Alles weitere wird von der AuftragBezahlenPage gemacht
            return result;
        }

        if (status.auftragsstatus == Auftragsstatus.Weiterleiten) {
            this.weiterleitenAnzeigen.next(status);
            result.abbruch = false;

            // Hier wird abgebrochen. Alles weitere wird von der xxxx gemacht
            return result;
        }

        let zusatzinfo: StatusmeldungZusatzinfo = null;

        if (status.statuszusatzinfo) {
            const statuszusatzinfoModal = await this.modalController.create({
                component: StatuszusatzinfoModalPage,
                componentProps: {
                    'workflowStatus': status,
                    'auftrag': auftrag
                }
            });

            log?.debug('statuszusatzinfoModal wird angezeigt...');
            await statuszusatzinfoModal.present();

            const modalResult = await statuszusatzinfoModal.onDidDismiss();

            zusatzinfo = modalResult.data.zusatzinfo

            log?.debug('statuszusatzinfoModal wurde geschlossen', zusatzinfo);

            if (!zusatzinfo) {
                // Abbruch
                result.abbruch = true;
                return rollback();
            }

            // Keine Rückfrage mehr.
            // Der Dialog wurde schon mit OK geschlossen und damit bestätigt
            mitRueckfrage = false;
        }

        if (status.auftragsstatus === Auftragsstatus.Abgeschlossen) {
            // Als letzte Prüfung vor dem Senden, damit Unterschrift, Fotos usw. schon vorhanden sind.
            // Danach ist der Auftrag archiviert und der Druck-Status meist nicht mehr erlaubt.
            const pflichtdruck = await this.pruefePflichtdruck(status);

            if (pflichtdruck.abbruch) {
                result.abbruch = true;
                return rollback();
            }

            if (pflichtdruck.dialogAngezeigt) {
                // Der Fahrer hat im Dialog schon entschieden (gedruckt oder ohne Druck bestätigt)
                mitRueckfrage = false;
            }

            // Immer neu setzen, damit kein Grund aus einem früheren, fehlgeschlagenen Versuch mitgeschickt wird
            const bisherigerGrund = auftrag.DruckUebersprungen;
            auftrag.DruckUebersprungen = pflichtdruck.uebersprungenGrund;
            undoActions.push(() => auftrag.DruckUebersprungen = bisherigerGrund);
        }

        if (mitRueckfrage) {
            if (workflow) {
                if (workflow.einstellungen.RueckfrageStatusmeldungen === 'nein') {
                    mitRueckfrage = false;
                }
            }
        }

        if (mitRueckfrage) {
            if (status.auftragsstatus == Auftragsstatus.FreigabeAnfordern) {
                const ok = await UiHelper.confirmJaNein('Freigabe wirklich anfordern?');

                if (!ok) {
                    result.abbruch = true;
                    return rollback();
                }
            } else if (status.auftragsstatus == Auftragsstatus.Angenommen) {
                const ok = await UiHelper.confirmJaNein('Auftrag wirklich annehmen?');

                if (!ok) {
                    result.abbruch = true;
                    return rollback();
                }
            } else if (status.auftragsstatus == Auftragsstatus.Abgelehnt) {
                const ok = await UiHelper.confirmJaNein('Auftrag wirklich ablehnen?');

                if (!ok) {
                    result.abbruch = true;
                    return rollback();
                }
            } else if (status.auftragsstatus == Auftragsstatus.Geloescht) {
                const ok = await UiHelper.confirmJaNein('Auftrag wirklich löschen?');

                if (!ok) {
                    result.abbruch = true;
                    return rollback();
                }
            } else if (status.auftragsstatus == Auftragsstatus.Gedruckt) {
                // Keine Rückfrage hier notwendig. Wird oben schon abgefangen
            } else {
                const ok = await UiHelper.confirmJaNein(`wirklich senden?`, status.name);

                if (!ok) {
                    result.abbruch = true;
                    return rollback();
                }
            }
        }

        try {
            MyApp.loading(true);

            await Utils.delay(250);

            let auftraegeAmEinsatzort: AuftragEx[] = [];

            if (status.FuerAlleAuftraegeAnEinsatzort) {
                // Diese Statusmeldung gilt für alle Aufträge am Einsatzort/für diesen Kunden.
                // ... d.h. zumindest für alle Aufträge die von der Reihenfolge gleich sind, also gleich vor oder nach diesem Auftrag kommen.
                // Das wurde für KLOH implementiert, da es bei AIS auch so vorhanden war.
                // Damit sollen die Zeiten richtig für die Aufträge erfasst werden (???).
                // Aktuell wird das nur für den Status "Ankunft am Leistungsort" verwendet.

                // Suche hier zuerst alle zusammenhängenden Aufträge, bevor die Statusmeldung gemacht wurde.
                auftraegeAmEinsatzort = await this.getAuftraegeAmEinsatzort(auftrag);
            }

            const zusatzdaten: StatusmeldungZusatzdaten = {
                zusatzinfo: zusatzinfo
            };

            const ok = await AuftragService.instance.statusmeldung(auftrag, status, zusatzdaten);

            if (!ok) {
                result.abbruch = true;
                return rollback();
            }

            if (status.FuerAlleAuftraegeAnEinsatzort && auftraegeAmEinsatzort.length) {
                // Diese Statusmeldung gilt für alle Aufträge am Einsatzort/für diesen Kunden.
                // ... d.h. zumindest für alle Aufträge die von der Reihenfolge gleich sind, also gleich vor oder nach diesem Auftrag kommen.
                // Das wurde für KLOH implementiert, da es bei AIS auch so vorhanden war.
                // Damit sollen die Zeiten richtig für die Aufträge erfasst werden (???).
                // Aktuell wird das nur für den Status "Ankunft am Leistungsort" verwendet.
                await this.meldeStatusmeldungFuerAlleAuftraegeAmEinsatzort(auftraegeAmEinsatzort, status, zusatzdaten);
            }

            if (status.AbholstelleFertig && this.workflow?.einstellungen?.Neutral === 'ja') {
                this.updateNeutralAktuelleAnsicht();
                this.neutralAktuelleGeaendert.next();
            }

            result.abbruch = false;

            if (aktuelleTour) {
                if (status.auftragsstatus == Auftragsstatus.Abgeschlossen) {
                    // Merke zur Tour, dass der Auftrag abgeschlossen wurde
                    if (!aktuelleTour.AbgeschlosseneAuftraege) {
                        aktuelleTour.AbgeschlosseneAuftraege = [];
                    }

                    const abgeschlossenerAuftrag: TourStatusAuftragsdaten = {
                        AuftragKey: auftrag.Key,
                        Auftragsnummer: auftrag.Auftragsnummer,
                        Auftragstyp: auftrag.Auftragstyp,
                        GewichtInKg: AuftragHelper.getSummeGewichtInKg(auftrag),
                        Mengen: AuftragHelper.getMengeMap(auftrag)
                    };

                    aktuelleTour.AbgeschlosseneAuftraege.push(abgeschlossenerAuftrag)

                    if (!aktuelleTour.SummeGewichtInKg) {
                        aktuelleTour.SummeGewichtInKg = 0;
                    }

                    aktuelleTour.SummeGewichtInKg += abgeschlossenerAuftrag.GewichtInKg;

                    await TourService.instance.speichereAktuelleTour();
                }
            }

            if (status.auftragsstatus >= Auftragsstatus.Unterbrochen) {
                let toastMessage = '';

                if (status.auftragsstatus == Auftragsstatus.Abgeschlossen) {
                    toastMessage = `Auftrag wurde abgeschlossen`;
                } else if (status.auftragsstatus == Auftragsstatus.Unterbrochen) {
                    toastMessage = `Auftrag wurde unterbrochen`;
                } else if (status.auftragsstatus == Auftragsstatus.FreigabeAnfordern) {
                    toastMessage = `Freigabe wird angefordert...`;
                } else if (status.auftragsstatus == Auftragsstatus.Abgelehnt) {
                    toastMessage = `Auftrag wurde storniert`;
                } else if (status.auftragsstatus == Auftragsstatus.Angenommen) {
                    toastMessage = `Auftrag wurde angenommen`;
                }

                if (toastMessage) {
                    const toast = await this.toastController.create({
                        message: toastMessage,
                        duration: 1000,
                        color: 'medium'
                    });

                    toast.present();
                }

                this.auftragAbgeschlossen.next('');
            } else {
                result.detectChanges = true;
                this.scrollToButtons.next('');
            }
        } catch (err) {
            UiHelper.showError(err);
        } finally {
            MyApp.loading(false);
        }

        this.updateAuftragReadOnly();

        this.detectChanges.next('statusmeldung');

        return result;
    }

    /**
     * Prüft ob für alle Auftragszeiterfassungen die Bemerkung eingegeben wurde, falls diese als Pflicht konfiguriert ist.
     * Das wird für Hubert Schmid benötigt, z.B. bei der Arbeitszeit "Wartezeit Kunde".
     * Hier sollen die Anwender immer eine Bemerkung eingeben müssen.
     */
    async pruefeZeiterfassungVollstaendig(): Promise<boolean> {
        if (AppConfig.current.einstellungen.AuftragZeiterfassungAktiv !== 'ja') {
            // Zeiterfassugn nicht aktiv. Deshalb alles gut, also TRUE zurückgeben
            return true;
        }

        const eintraege = Zeiterfassung.getAuftragszeiten(this.auftrag);

        for (const zeitEintrag of eintraege) {
            if (Utils.isBlank(zeitEintrag.Bemerkung)) {
                // Es wurde keine Bemerkung eingegeben.
                // Prüfe ob die Bemerkung für diese Arbeitszeit als Pflicht konfiguriert ist.
                const art = AppConfig.current.arbeitszeitKonfiguration?.AuftragArbeitszeitArten?.find(p => p.Key == zeitEintrag.ArtKey);

                if (art && art.BemerkungPflicht) {
                    const text = I18N.instant('Meldung432', { NAME: zeitEintrag.ArtName });

                    await UiHelper.showAlert(text, 'Achtung');

                    return false;
                }
            }
        }

        return true;
    }

    async getAuftraegeAmEinsatzort(auftrag: AuftragEx): Promise<AuftragEx[]> {
        if (!auftrag?.Abholadresse?.AdressNummer) {
            log.warn('getAuftraegeAmEinsatzort: Abholadresse.AdressNummer nicht gesetzt. Das sollte nicht sein');
            return [];
        }

        const aktuelleAuftraege = await AuftragService.instance.getAktuelleAuftraege(auftrag.Auftragstyp);

        AuftragHelper.sortiereAuftraege(aktuelleAuftraege);

        const idx = aktuelleAuftraege.findIndex(p => p.Key == auftrag.Key);

        if (idx < 0) {
            // Das darf eigentlich nicht eintreten.
            log.warn('getAuftraegeAmEinsatzort: Index des aktuellen Auftrags nicht gefunden. Das sollte nicht sein: ' + idx);
            return [];
        }

        const listItems: AuftragListItem[] = [];

        // Suche ab dem Index nach vorne und hinten nach Aufträgen am gleichen Einsatzort und zum gleichen Kunden

        // Zuerst nach vorne
        for (let i = idx - 1; i >= 0; i--) {
            const a = aktuelleAuftraege[i];

            if (a?.Abholadresse?.AdressNummer === auftrag.Abholadresse.AdressNummer
                && a.Abholadresse.Name1 == auftrag.Abholadresse.Name1
                && a.Abholadresse.PLZ == auftrag.Abholadresse.PLZ
                && a.Abholadresse.Ort == auftrag.Abholadresse.Ort
                && a.Abholadresse.Strasse == auftrag.Abholadresse.Strasse) {

                // Gleiche Adresse
                listItems.push(a);
            } else {
                // Nicht weiter suchen. Es sollen nur Aufträge gefunden werden die direkt davor/dahinter stehen
                break;
            }
        }

        // Und nach hinten
        for (let i = idx + 1; i < aktuelleAuftraege.length; i++) {
            const a = aktuelleAuftraege[i];

            if (a?.Abholadresse?.AdressNummer === auftrag.Abholadresse.AdressNummer
                && a.Abholadresse.Name1 == auftrag.Abholadresse.Name1
                && a.Abholadresse.PLZ == auftrag.Abholadresse.PLZ
                && a.Abholadresse.Ort == auftrag.Abholadresse.Ort
                && a.Abholadresse.Strasse == auftrag.Abholadresse.Strasse) {

                // Gleiche Adresse
                listItems.push(a);
            } else {
                // Nicht weiter suchen. Es sollen nur Aufträge gefunden werden die direkt davor/dahinter stehen
                break;
            }
        }

        const resultList: AuftragEx[] = [];

        if (listItems.length) {
            log?.debug('Anzahl gleiche Aufträge zum Einsatzort: ' + listItems.length);

            for (const item of listItems) {
                log?.debug('Auftrag am Einsatzort: ' + item.Key);

                // Hole den richtigen Auftrag zum ListItem
                const a2 = await this.auftragService.getAuftrag(item.Key);

                if (a2) {
                    resultList.push(a2);
                }
            }
        }

        return resultList;
    }

    async meldeStatusmeldungFuerAlleAuftraegeAmEinsatzort(auftraegeAmEinsatzort: AuftragEx[], status: WorkflowStatus, zusatzdaten: StatusmeldungZusatzdaten) {
        const workflow = this.workflow;

        // Aufträge mit Pflichtdruck werden nicht automatisch mit abgeschlossen
        const nichtAbgeschlossen: AuftragEx[] = [];

        for (const a2 of auftraegeAmEinsatzort) {
            log?.debug(`Statusmeldung für Auftrag em Einsatzort: ${a2.Key}, ${status.name}`);

            const erlaubt = AuftragService.instance.istStatusuebergangErlaubt(a2, workflow, status);

            if (!erlaubt) {
                log.warn(`Statusübergang für Auftrag em Einsatzort nicht erlaubt`);
                continue;
            }

            if (status.auftragsstatus === Auftragsstatus.Abgeschlossen && AuftragHelper.istPflichtdruckErforderlich(a2) && !AuftragHelper.istAuftragGedruckt(a2, workflow)) {
                log?.info(`Auftrag am Einsatzort wird wegen Pflichtdruck nicht mit abgeschlossen: ${a2.Key}`);
                nichtAbgeschlossen.push(a2);
                continue;
            }

            await AuftragService.instance.statusmeldung(a2, status, zusatzdaten);
        }

        if (nichtAbgeschlossen.length) {
            const auftraege = nichtAbgeschlossen.map(p => p.Auftragsnummer > 0 ? p.Auftragsnummer : p.Key).join(', ');

            await UiHelper.showAlert(`Diese Aufträge am Einsatzort müssen gedruckt werden und wurden nicht mit abgeschlossen: ${auftraege}. Bitte einzeln abschließen.`, 'Druck erforderlich', true);
        }
    }

    pruefeAuftragspositionenVollstaendig(): string {
        const auftrag = this.auftrag;

        if (!auftrag.Positionen || auftrag.Positionen.length == 0) {
            return null;
        }

        const artikelList = StammdatenService.instance.getAlleArtikel().getValue();

        let laderaumAuswahlAktiv = false;

        if (auftrag.Auftragstyp === Auftragstyp.Transportauftrag) {
            laderaumAuswahlAktiv = AppConfig.current.einstellungen.TransportauftragLaderaumAuswahlAktiv === 'ja';
        }

        let abschliessenOhneWiegungen = AppConfig.current.einstellungen.TransportauftragPositionWiegenAbschliessenOhneWiegungen === 'ja';

        let fehlertext = '';

        const behaelterAbstellorteVerwenden = MyApp.current.behaelterAbstellorteVerwenden.getValue();

        for (const p of auftrag.Positionen) {
            if (p.Menge !== null) {
                if (typeof (p.Menge) === 'string' && p.Menge !== '' && p.Menge !== null) {
                    p.Menge = Utils.parseFloat(p.Menge);
                }
            }

            if (!p.Menge && p.Menge !== 0 && p.MengeOption !== MengeOptionTyp.NichtAenderbar) {
                fehlertext = 'Fehlende Menge';
                return fehlertext;
            }

            // TODO Kontrolle
            if (!p.Menge && p.Menge <= 0 && p.MengeOption === MengeOptionTyp.AenderbarGroesserNull) {
                fehlertext = 'Menge muss größer 0 sein';
                return fehlertext;
            }

            if (p.GewichtInKgAktiv && p.GewichtInKgPflicht) {
                if (p.GewichtInKg !== null && p.GewichtInKg as any != '') {
                    p.GewichtInKg = Utils.parseFloat(p.GewichtInKg);

                    if (isNaN(p.GewichtInKg)) {
                        p.GewichtInKg = null;
                    }
                }

                //  && p.GewichtInKg !== 0
                if (!p.GewichtInKg && p.Menge !== 0) {
                    fehlertext = 'Gewicht in kg';
                    return fehlertext;
                }
            }

            if (!abschliessenOhneWiegungen && p.AuftragWiegungAktiv && p.Wiegungen2 && p.Wiegungen2?.length > 0) {
                // TODO bei einer Handwiegung kann im Gewicht "" stehen. Wie soll das abgefangen werden?
                // || p.Wiegungen2[0].Gewicht.toString() === "" 
                const gewicht1 = p.Wiegungen2[0]?.Gewicht as any;
                const gewicht2 = p.Wiegungen2[1]?.Gewicht as any;

                if (gewicht1 == null || gewicht1 == '' || gewicht2 == null || gewicht2 == '') {
                    fehlertext = 'Beide Wiegungen müssen vorhanden sein';
                    return fehlertext;
                }
            }

            if (laderaumAuswahlAktiv && p.Menge) {
                const fahrzeug = MyApp.current.fahrzeug.getValue();

                if (fahrzeug && fahrzeug.Laderaeume) {
                    // Prüfen ob für den Artikel ein Laderaum gewählt werden muss
                    let laderaumErforderlich = false;

                    if (p.LaderaumAuswahlAktiv !== null && typeof (p.LaderaumAuswahlAktiv) !== 'undefined') {
                        laderaumErforderlich = p.LaderaumAuswahlAktiv;
                    } else if (p.ArtikelKey) {
                        const artikel = artikelList.find(x => x.artikelKey as any == p.ArtikelKey);

                        if (artikel) {
                            laderaumErforderlich = artikel.LaderaumAuswahlAktiv;
                        }
                    }

                    if (laderaumErforderlich) {
                        if (fahrzeug.Laderaeume.length == 1) {
                            // Nur ein Laderaum vorhanden. Automatisch füllen
                            if (fahrzeug.Laderaeume[0].Nummer) {
                                p.Laderaum = fahrzeug.key + '-' + fahrzeug.Laderaeume[0].Nummer.toString();
                            }
                        }

                        if (!p.Laderaum && fahrzeug.Laderaeume.length > 1) {
                            fehlertext = 'Laderaum';
                            return fehlertext;
                        }
                    }
                }
            }

            if (p.BhAktion && p.Menge > 0) {
                const bhAktion = p.BhAktion.toLowerCase().trim();
                let anzahl = Math.ceil(p.Menge);

                if (anzahl > 100) {
                    anzahl = 100;
                }

                switch (bhAktion) {
                    case 'tauschen':
                        anzahl = anzahl * 2;
                        break;
                }

                if (!p.Behaelter || p.Behaelter.length != anzahl) {
                    fehlertext = 'Fehlende Behälter-Nummer';
                    return fehlertext;
                }

                for (const behaelter of p.Behaelter) {
                    if (!behaelter.BehaelterNr) {
                        fehlertext = 'Behälter-Nummer darf nicht leer sein';
                        return fehlertext;
                    }

                    if (behaelterAbstellorteVerwenden) {
                        if (behaelter.Aktion === 'abziehen') {
                            if (!behaelter.Abstellort) {
                                fehlertext = 'Abstellort für Behälter ' + behaelter.BehaelterNr + ' nicht ausgewählt';
                                return fehlertext;
                            }

                            if (!behaelter.Zustand) {
                                fehlertext = 'Zustand für Behälter ' + behaelter.BehaelterNr + ' nicht ausgewählt (voll / leer)';
                                return fehlertext;
                            }
                        }
                    }
                }
            }
        }

        // Eigenschaften prüfen

        for (const position of auftrag.Positionen) {
            if (!position.Eigenschaften) {
                continue;
            }

            if (!position.Menge) {
                continue;
            }

            for (const eigenschaft of position.Eigenschaften) {
                if (eigenschaft.isAusgeblendet) {
                    // Ausgeblendete Eigenschaften dürfen den Auftrag nie blockieren.
                    // Der Fahrer sieht sie nicht und kann sie deshalb auch nicht ausfüllen.
                    continue;
                }

                if (eigenschaft.Regex) {
                    try {
                        const wert = Utils.trimToEmpty(eigenschaft.Wert);

                        if (!wert.match(eigenschaft.Regex)) {
                            if (wert) {
                                fehlertext = `Eigenschaft '${eigenschaft.Bezeichnung}' für Position ${position.PosNr} ungültig`;
                            } else {
                                fehlertext = `Eigenschaft '${eigenschaft.Bezeichnung}' für Position ${position.PosNr} darf nicht leer sein`;
                            }

                            return fehlertext;
                        }
                    } catch (err) {
                        log.warn('Fehler beim Testen des Regex ' + eigenschaft.Regex + ' für Wert ' + eigenschaft.Wert + ': ' + Utils.getErrorMessage(err));
                    }
                }
            }
        }

        return null;
    }

    pruefeLeergutVollstaendig(): string {
        const auftrag = this.auftrag;

        if (!auftrag.RetourPositionen || auftrag.RetourPositionen.length == 0) {
            return null;
        }

        // const artikelList = StammdatenService.instance.getAlleArtikel().getValue();

        // let laderaumAuswahlAktiv = false;

        // if (auftrag.Auftragstyp === Auftragstyp.Transportauftrag) {
        //     laderaumAuswahlAktiv = AppConfig.current.einstellungen.TransportauftragLaderaumAuswahlAktiv === 'ja';
        // }

        let fehlertext = '';

        // const behaelterAbstellorteVerwenden = App.current.behaelterAbstellorteVerwenden.getValue();

        for (const p of auftrag.RetourPositionen) {
            if (p.Menge !== null) {
                if (typeof (p.Menge) === 'string' && p.Menge !== '' && p.Menge !== null) {
                    p.Menge = Utils.parseFloat(p.Menge);
                }
            }

            if (!p.Menge && p.Menge !== 0 && p.MengeOption !== MengeOptionTyp.NichtAenderbar) {
                fehlertext = 'Fehlende Menge';
                return fehlertext;
            }

            if (p.GewichtInKgAktiv && p.GewichtInKgPflicht) {
                if (p.GewichtInKg !== null && p.GewichtInKg as any != '') {
                    p.GewichtInKg = Utils.parseFloat(p.GewichtInKg);

                    if (isNaN(p.GewichtInKg)) {
                        p.GewichtInKg = null;
                    }
                }

                //  && p.GewichtInKg !== 0
                if (!p.GewichtInKg && p.Menge !== 0) {
                    fehlertext = 'Gewicht in kg';
                    return fehlertext;
                }
            }
        }

        // Eigenschaften prüfen

        for (const position of auftrag.RetourPositionen) {
            if (!position.Eigenschaften) {
                continue;
            }

            if (!position.Menge) {
                continue;
            }

            for (const eigenschaft of position.Eigenschaften) {
                if (eigenschaft.isAusgeblendet) {
                    // Ausgeblendete Eigenschaften dürfen den Auftrag nie blockieren.
                    // Der Fahrer sieht sie nicht und kann sie deshalb auch nicht ausfüllen.
                    continue;
                }

                if (eigenschaft.Regex) {
                    try {
                        const wert = Utils.trimToEmpty(eigenschaft.Wert);

                        if (!wert.match(eigenschaft.Regex)) {
                            if (wert) {
                                fehlertext = `Eigenschaft '${eigenschaft.Bezeichnung}' für Retour-Position ${position.PosNr} ungültig`;
                            } else {
                                fehlertext = `Eigenschaft '${eigenschaft.Bezeichnung}' für Retour-Position ${position.PosNr} darf nicht leer sein`;
                            }

                            return fehlertext;
                        }
                    } catch (err) {
                        log.warn('Fehler beim Testen des Regex ' + eigenschaft.Regex + ' für Wert ' + eigenschaft.Wert + ': ' + Utils.getErrorMessage(err));
                    }
                }
            }
        }

        return null;
    }

    async pruefeChecklistenVollstaendig(): Promise<string> {
        const auftrag = this.auftrag;
        const checklisten = this.checklisten;

        if (!checklisten || !checklisten.length) {
            // Keine Checklisten vorhanden. Deshalb immer vollständig
            return '';
        }

        // if (!this.auftrag.ChecklistenErgebnis || this.auftrag.ChecklistenErgebnis.length <= 0) {
        //     // noch gar kein Ergebnis vorhanden
        //     log?.info(`Gar keine Ergebnisse für Checklisten vorhanden`);
        //     return false;
        // }

        for (const checkliste of checklisten) {
            let ergebnis = auftrag.ChecklistenErgebnis.find(p => p.ChecklisteName == checkliste.name);

            if (!ergebnis) {
                ergebnis = {
                    ChecklisteName: checkliste.name,
                    Eintraege: []
                };

                auftrag.ChecklistenErgebnis.push(ergebnis);
            }

            for (const eintrag of checkliste.eintraege) {
                if (eintrag.Aktiv === false) {
                    // Eintrag ist nicht aktiv, deshalb überspringen
                    // Hier wird extra auf === false geprüft. In alten Versionen könnte das noch NULL sein.
                    continue;
                }

                let status = ergebnis.Eintraege.find(p => p.Key == eintrag.key);

                const config = ChecklistHelper.parseConfig(eintrag);

                if (config.erforderlich === false) {
                    // Eingabe ist explizit nicht erforderlich
                    continue;
                }

                if (config.default) {
                    if (!status) {
                        status = { Key: eintrag.key, Text: eintrag.text };
                        ergebnis.Eintraege.push(status);
                    }

                    if (!status.Status) {
                        status.Status = config.default;
                    }
                } else if (eintrag.antworten == '5') {
                    // Toggle
                    if (!status) {
                        status = { Key: eintrag.key, Text: eintrag.text };
                        ergebnis.Eintraege.push(status);
                    }

                    if (!status.Status) {
                        status.Status = 'nein';
                    }
                } else if (eintrag.antworten == '9') {
                    // Zahl. 
                } else if (eintrag.antworten == '7') {
                    // Fotos
                    if (status?.Bilder?.length > 0) {
                        // Fotos vorhanden
                        status.Status = 'OK';
                    } else if (status) {
                        status.Status = '';
                    }
                } else if (eintrag.antworten == '10') {
                    // Überschrift. Keine Eingabe erforderlich
                    continue;
                }

                if (!status) {
                    log?.info(`Kein Status für Checkliste '${checkliste.name}' Eintrag: ${eintrag.text}`);
                    return eintrag.text;
                }

                if (status.Status == null || status.Status === '') {
                    log?.info(`Keine Antwort für Checkliste '${checkliste.name}' Eintrag: ${eintrag.text}`);
                    return eintrag.text;
                }
            }
        }

        return '';
    }

    async preufeAuftragNichtZugewiesen(auftrag: AuftragEx): Promise<boolean> {
        if (auftrag.Geraet === AppConfig.current.geraeteNummer) {
            return false;
        }

        const listItem = AuftragService.instance.getAuftragListItem(auftrag.Key);

        return await this.preufeAuftragListItemNichtZugewiesen(listItem);
    }

    async preufeAuftragListItemNichtZugewiesen(auftrag: AuftragListItem): Promise<boolean> {
        if (auftrag.Geraet === AppConfig.current.geraeteNummer) {
            return false;
        }

        switch (auftrag.Auftragstyp) {
            case Auftragstyp.Transportauftrag:
                if (AppConfig.current.einstellungen.TransportauftraegeAnGeraetegruppeManuellZuweisen !== 'ja') {
                    return false;
                }
                break;

            case Auftragstyp.Hofchecker:
                if (AppConfig.current.einstellungen.HofauftraegeAnGeraetegruppeManuellZuweisen !== 'ja') {
                    return false;
                }
                break;

            case Auftragstyp.Kommissionierung:
                if (AppConfig.current.einstellungen.KommissionierungAuftraegeAnGeraetegruppeManuellZuweisen !== 'ja') {
                    return false;
                }

                // Oberaufträge müssen nicht zugewiesen werden
                if (!auftrag.OberAuftragKey) {
                    return false;
                }

                break;

            case Auftragstyp.Wareneingang:
                return false; // TODO: Eventuell konfigurierbar machen
        }

        if (auftrag.GeraeteGruppe) {
            const ok = await UiHelper.confirmJaNein('Auftrag wurde noch nicht diesem Gerät zugewiesen. Jetzt zuweisen?');

            if (ok) {
                const success = await this.zuweisenAuftrag(auftrag, true);

                if (success) {
                    return false;
                }
            }

            return true;
        } else {
            return false;
        }
    }

    async zuweisenAuftrag(auftragListItem: AuftragListItem, zugewiesen: boolean): Promise<boolean> {
        let success = false;

        MyApp.loadingDelayed(true);

        try {
            const result = await RemoteService.instance.zuweisenAuftrag({
                Key: auftragListItem.Key,
                Zuweisen: zugewiesen
            });

            MyApp.loading(false);

            if (!result) {
                UiHelper.showFehlerKommunikation();
                return;
            }

            if (result.success) {
                if (zugewiesen) {
                    auftragListItem.Auftragsstatus = Auftragsstatus.Zugewiesen;
                    auftragListItem.Geraet = AppConfig.current.geraeteNummer;
                    auftragListItem.istZugewiesen = zugewiesen;
                    auftragListItem.istAnderemGraetZugewiesen = false;
                } else {
                    auftragListItem.Auftragsstatus = Auftragsstatus.Neu;
                    auftragListItem.Geraet = null;
                    auftragListItem.istZugewiesen = false;
                }

                const auftrag = await AuftragService.instance.getAuftrag(auftragListItem.Key);

                if (zugewiesen) {
                    auftrag.Geraet = AppConfig.current.geraeteNummer;

                    if (auftrag.Auftragsstatus < 35) {
                        auftrag.Auftragsstatus = 35;
                    }
                } else {
                    // Zuweisung wurde aufgehoben
                    auftrag.Geraet = '';

                    if (auftrag.Auftragsstatus < 90) {
                        auftrag.Auftragsstatus = 10;
                    }
                }

                await AuftragService.instance.speichereAuftrag(auftrag);

                success = true;
            } else {
                UiHelper.showError(result.message, 'Fehler', false, false);
                auftragListItem.istZugewiesen = false;
            }
        } catch (err) {
            MyApp.loading(false);

            UiHelper.showError(err);
            auftragListItem.istZugewiesen = false;
        }

        setTimeout(() => {
            this.detectChanges.next('zuweisenAuftrag');
            // this.detectChanges('zuweisenAuftrag');
        });

        return success;
    }

    async starteNavigation(adresse: Adresse) {
        log?.info('starteNavigation');

        if (!await this.pruefeZeiterfassungGestartet()) {
            return;
        }

        if (this.isNavigationGesperrt) {
            this.showAuftragSchreibgeschuetzt();
            return;
        }

        SystemService.instance.starteNavigation(adresse);

        // Navigation kann auch bei schreibgeschütztem Auftrag gestartet werden.
        // Das wird hauptsächlich am Vorabend von den Fahrern verwendet, um bereits die Tour anzuschauen.
        // Es soll dann aber keine Nachricht an den Server geschickt werden
        if (!this.isReadOnly) {
            SystemService.instance.sendeTextdatei({
                typ: TextdateiTyp.StartNavigation,
                Navigation: {
                    Adresse: adresse,
                    AuftragKey: this.auftrag?.Key
                }
            }, true);
        }

        // this.starteAuftragWennErforderlich('Navigation');
    }

    /**
     * Prüft ob die Zeiterfassung gestartet wurde und frägt den Benutzer ob er diese eventuell starten möchte.
     * Gibt FALSE zurück, falls die Zeiterfassung erforderlich ist und nicht gestartet wurde 
     */
    async pruefeZeiterfassungGestartet(): Promise<boolean> {
        if (AppConfig.current.einstellungen.AuftragZeiterfassungAktiv !== 'ja') {
            // Zeiterfassugn nicht aktiv. Deshalb alles gut, also TRUE zurückgeben
            return true;
        }

        if (this.auftrag.zeiterfassungLaeuft) {
            return true;
        }

        // Wenn ein manuell bearbeiteter Wert vorhanden ist, dann darf auch immer bearbeitet werden.
        // Ansonsten hat man nicht die möglichkeit einen Wert manuell einzugeben und anschließend den Auftrag fertig zu melden
        const zeiten = Zeiterfassung.getAuftragszeiten(this.auftrag);

        if (zeiten.find(p => p.Typ === 'Manuell')) {
            return true;
        }

        const ok = await UiHelper.confirmJaNein('Zeiterfassung starten?');

        if (ok) {
            if (AuftragHelper.isAuftragImArchiv(this.auftrag)) {
                UiHelper.showErrorLight('Zeiterfassung für archivierte Aufträge nicht erlaubt');
                return false;
            }

            if (this.isReadOnly) {
                UiHelper.showErrorLight('Auftrag ist schreibgeschützt. Zeiterfassung kann nicht gestartet werden.');
                return;
            }

            let art: ArbeitsartKonfiguration = null;

            if (AppConfig.current.einstellungen.AuftragZeiterfassungTyp === 'MitArt') {
                art = AppConfig.current.arbeitszeitKonfiguration?.AuftragArbeitszeitArten?.find(p => p.Standard);

                if (!art) {
                    UiHelper.showErrorLight('Keine Standard-Arbeitszeit konfiguriert. Zeiterfassung muss manuell gestartet werden.');
                    return false;
                }
            }

            return await this.starteZeiterfassung(art);
        }

        return false;
    }

    async starteZeiterfassung(art: ArbeitsartKonfiguration = null): Promise<boolean> {
        if (AuftragHelper.isAuftragImArchiv(this.auftrag)) {
            return false;
        }

        // Prüfe ob noch die Zeiterfassung von einem anderen Auftrag läuft. Wenn ja, dann muss diese erst gestoppt werden
        if (AppConfig.current.einstellungen.AuftragZeiterfassungNurEinAktiverAuftrag === "ja") {
            const ok = await Zeiterfassung.beendeLaufendeZeiterfassungMitRueckfrage();

            if (!ok) {
                return false;
            }
        }

        const ok = await this.auftragService.starteZeiterfassung(this.auftrag, art);

        if (ok) {
            this.starteAuftragWennErforderlich('starteZeiterfassung');
        }

        this.updateAuftragReadOnly();

        this.detectChanges.next('starteZeiterfassung');

        this.auftragService.zeiterfassungLetzterAuftragKey = null;
    }

    async unterbrecheZeiterfassung() {
        await this.auftragService.unterbrecheZeiterfassung(this.auftrag);

        this.updateAuftragReadOnly();

        this.detectChanges.next('unterbrecheZeiterfassung');
    }

    getEinstellung(komponente: AuftragsKomponente, key: string, defaultValue: string): string {
        if (!komponente || !komponente.einstellungen) {
            return defaultValue;
        }

        const einstellung = komponente.einstellungen.find(p => p.key === key);

        if (einstellung) {
            if (einstellung.wert !== null && einstellung.wert !== '' && einstellung.wert !== undefined) {
                return einstellung.wert.trim();
            }
        }

        return defaultValue;
    }

    getStyle(komponente: AuftragsKomponente): string {
        let result = '';

        const opacity = this.getEinstellung(komponente, 'Opacity', null);

        if (opacity) {
            result = 'opacity: ' + opacity + ';';
        }

        return result;
    }

    async anrufen(adresse: Adresse) {
        log?.debug('onAnrufen');

        const auftrag = this.auftrag;
        const kontakte = AuftragHelper.getAdressKontakteZumAnrufen(auftrag, adresse);

        if (kontakte.length == 1) {
            // Direkt anrufen
            SystemService.instance.anrufenTelefonnummer(kontakte[0].Telefon);
        } else {
            this.isModalSichtbar = true;

            const modal = await this.modalController.create({
                component: KontaktlisteComponent,
                cssClass: 'kontaktliste-modal',
                // swipeToClose: true, // TODO CAPACITOR     
                animated: true,
                backdropDismiss: true,
                showBackdrop: true,
                componentProps: {
                    kontakte: kontakte
                }
            });

            await modal.present();

            const result = await modal.onDidDismiss();

            this.isModalSichtbar = false;

            if (result && result.data) {
                const kontakt = result.data as Kontakt;
                SystemService.instance.anrufenTelefonnummer(kontakt.Telefon);
            }
        }
    }

    async frageAdresseAktion(komponente: AuftragsKomponente, adresse: Adresse): Promise<{ aktion: string, data?: any }> {
        return new Promise(async resolve => {
            const buttons: any[] = [];

            if (this.auftrag.IstNeuanlage) {
                buttons.push({
                    text: 'Adresse ändern',
                    icon: 'create',
                    handler: () => {
                        resolve({ aktion: 'adresse-aendern' });
                    }
                });
            }

            if (this.getEinstellung(komponente, "Navigation", "ja") === 'ja') {
                const navigationMoeglich = this.workflow.einstellungen.Navigation !== 'nein';

                if (navigationMoeglich) {
                    buttons.push({
                        text: 'Navigation starten',
                        icon: 'navigate',
                        handler: () => {
                            resolve({ aktion: 'navigation' });
                        }
                    });
                }
            }

            const kontakte = AuftragHelper.getAdressKontakteZumAnrufen(this.auftrag, adresse);

            for (const kontakt of kontakte) {
                let name = kontakt.Name;

                if (!name) {
                    name = kontakt.Telefon;
                }

                buttons.push({
                    text: name + ' anrufen\n' + kontakt.Telefon,
                    icon: 'call',
                    handler: () => {
                        resolve({ aktion: 'Anrufen', data: kontakt });
                    }
                });
            }

            if (buttons.length == 0) {
                return;
            }

            buttons.push({
                text: 'Abbruch',
                icon: 'close',
                role: 'cancel',
                handler: () => {
                    resolve(null);
                }
            });

            // const header = this.getEinstellung(komponente, 'Titel', 'Adresse');

            const alert = await this.alertController.create({
                cssClass: 'no-text-alert no-title-alert',
                mode: 'ios',
                buttons: buttons
            });

            await alert.present();

            // const actionSheet = await this.actionSheetController.create({
            //     header,
            //     buttons
            // });

            // await actionSheet.present();
        });
    }

    async ladeChecklisten(): Promise<void> {
        const namen: string[] = [];

        if (this.workflow && this.workflow.checkliste) {
            namen.push(this.workflow.checkliste);
        }

        if (this.auftrag.ChecklistenVorgabe) {
            for (const vorgabe of this.auftrag.ChecklistenVorgabe) {
                if (vorgabe.ChecklisteName && namen.indexOf(vorgabe.ChecklisteName) < 0) {
                    namen.push(vorgabe.ChecklisteName);
                }
            }
        }

        this.checklisten = [];

        // Werden Checklisten in der Formularkonfiguration angezeigt?
        // Wenn nicht ist etwas falsch konfiguriert
        if (namen.length) {
            const komponente = this.formularKonfiguration.komponenten.find(p => p.name === 'Checkliste');

            if (!komponente) {
                log.warn('Dieser Auftrag enthält eine Checkliste. Das Formular ist jedoch nicht für die Anzeige von Checklisten konfiguriert. Checkliste: ' + namen[0]);
                // UiHelper.showErrorOhneSentry('Dieser Auftrag enthält eine Checkliste. Das Formular ist jedoch nicht für die Anzeige von Checklisten konfiguriert. Bitte wenden Sie Sich an Ihren Administrator! Checkliste: ' + namen[0]);
                return;
            }
        }

        for (const checklisteName of namen) {
            const checkliste = await this.stammdatenService.getCheckliste(checklisteName);

            if (checkliste) {
                this.checklisten.push(checkliste);
            } else {
                UiHelper.showError('Checkliste nicht gefunden: ' + checklisteName);
            }
        }

        log?.debug('ladeChecklisten', this.checklisten);
    }

    initButtons() {
        this.buttons = [];
        this.buttons2 = [];
        this.buttons3 = [];
        this.buttonsAuftragPopup = [];

        const istAuftragAbgeschlossen = this.istAuftragAbgeschlossen;

        if (this.workflow) {
            if (!this.workflow.status) {
                this.workflow.status = [];
            }

            let moeglicheStatus = this.workflow.status;

            if (istAuftragAbgeschlossen) {
                moeglicheStatus = moeglicheStatus.filter(p => p.NachAbschlussErlaubt);
            }

            moeglicheStatus = moeglicheStatus.sort((a, b) => a.sortierung - b.sortierung);

            for (const workflowStatus of moeglicheStatus) {
                let color = 'light';

                if (workflowStatus.buttonFarbe) {
                    color = workflowStatus.buttonFarbe;
                }

                if (this.isStatusmeldungGesperrt) {
                    if (!workflowStatus.NachAbschlussErlaubt
                        && workflowStatus.auftragsstatus !== Auftragsstatus.Weiterleiten
                        && workflowStatus.auftragsstatus !== Auftragsstatus.Angenommen
                        && workflowStatus.auftragsstatus !== Auftragsstatus.Abgelehnt) {

                        continue;
                    }
                }

                if (this.auftrag?.Auftragstyp === Auftragstyp.Kommissionierung) {
                    // Vollpalette melden ist nur für Aufträge mit einer Position erlaubt
                    // Abgelehnt => Vollpalette: später holen
                    if (workflowStatus.auftragsstatus === Auftragsstatus.Abgelehnt) {
                        // "Abgelehnt" bedeutet, dass die Palette nicht kommissioniert wird, weil es sich um eine Vollpalette handelt
                        // Der Button soll nicht angezeigt werden, wenn es keine Vollpalette ist
                        if (!this.auftrag.istVollePalette) {
                            continue;
                        }
                    }
                }

                if (workflowStatus.buttonAnzeigen) {
                    this.buttons.push({
                        workflowStatus,
                        color,
                        icon: workflowStatus.icon,
                        text: workflowStatus.name
                    })
                }

                if (workflowStatus.ButtonAnzeigen2) {
                    this.buttons2.push({
                        workflowStatus,
                        color,
                        icon: workflowStatus.icon,
                        text: workflowStatus.name
                    })
                }

                if (workflowStatus.ButtonAnzeigen3) {
                    this.buttons3.push({
                        workflowStatus,
                        color,
                        icon: workflowStatus.icon,
                        text: workflowStatus.name
                    })
                }

                if (workflowStatus.InAuftragsPopupAnzeigen) {
                    this.buttonsAuftragPopup.push({
                        workflowStatus,
                        color,
                        icon: workflowStatus.icon,
                        text: workflowStatus.name
                    })
                }
            }

            if (this.workflow.einstellungen && this.workflow.einstellungen.StatusmeldungButtonAnzeigen !== 'nein') {
                // Wurden bereits alle Buttons hinzugefügt, dann ist kein extra "Statusmeldung"-Button mehr notwendig
                if (this.buttons.length < moeglicheStatus.length) {
                    let text = I18N.instant('Statusmeldung') + '...';

                    if (this.auftrag.Auftragstyp === Auftragstyp.Kommissionierung) {
                        // TODO: Sollte konfigurierbar sein
                        text = '...';
                    }

                    this.buttons.push({
                        text: text,
                        color: 'light',
                        workflowStatus: null,
                        icon: null
                    })
                }
            }
        }
    }

    async onFotoAufnehmen() {
        if (this.istAuftragAbgeschlossen) {
            UiHelper.showAlert(I18N.instant('AuftragBereitsAbgeschlossen'));
            return;
        }

        if (this.isBilderErfassenGesperrt) {
            UiHelper.showAlert(I18N.instant('AuftragDarfNichtGeaendertWerden'));
            return;
        }

        if (!await this.pruefeZeiterfassungGestartet()) {
            return;
        }

        this.kameraAktiv = true;

        let text = AppConfig.current.einstellungen.FotosTextAuftrag;

        const platzhalter = DruckerHelper.erstellePlatzhalter(
            this.auftrag,
            MyApp.current.fahrer.getValue(),
            MyApp.current.fahrzeug.getValue(),
            null);

        if (text.includes('{GPS}')) {
            platzhalter['GPS'] = await SystemService.instance.getAktuelleGpsPositionStr('Bild', 10);
        }

        let pictureSrc = await CameraHelper.takePicture({
            filenamePrefix: 'auftrag-' + this.auftrag.Auftragsnummer,
            textPlatzhalter: platzhalter,
            text: text,
        });

        if (!pictureSrc) {
            setTimeout(() => {
                this.kameraAktiv = false;
            }, 250);

            return;
        }

        log?.debug('pictureSrc', pictureSrc);

        const bild: ReCoMobilBild = {
            Datum: new Date().toISOString(),
            // Bild: imageData,
            BildGuid: Utils.uuid()
        };

        await AuftragService.instance.speichereBild(bild.BildGuid, pictureSrc);

        if (!this.auftrag.Auftragsbilder) {
            this.auftrag.Auftragsbilder = [];
        }

        this.auftrag.Auftragsbilder.push(bild);

        const bildVo = await this.createBildVo(bild);
        this.auftragsbilder.push(bildVo);

        this.detectChanges.next('onFotoAufnehmen');

        // Optionalen Kommentar erst nach der Erfassung des Bildes abfragen (nur wenn per Einstellung aktiviert)
        if (this.istBildKommentarAktiv) {
            await this.bearbeiteBildKommentar(bildVo, bild, false);
        }

        await AuftragService.instance.speichereAuftrag(this.auftrag);

        await this.starteAuftragWennErforderlich('onFotoAufnehmen');

        this.detectChanges.next('onFotoAufnehmen');

        setTimeout(() => {
            this.kameraAktiv = false;
        }, 250);

        // setTimeout(() => this.content.scrollToBottom(300), 250);
    }


    async onFotoAuswaehlen() {
        if (this.istAuftragAbgeschlossen) {
            UiHelper.showAlert(I18N.instant('AuftragBereitsAbgeschlossen'));
            return;
        }

        if (this.isBilderErfassenGesperrt) {
            UiHelper.showAlert(I18N.instant('AuftragDarfNichtGeaendertWerden'));
            return;
        }

        if (!await this.pruefeZeiterfassungGestartet()) {
            return;
        }



        try {
            this.kameraAktiv = true;

            MyApp.loading(true);

            let text = AppConfig.current.einstellungen.FotosTextAuftrag;

            const platzhalter = DruckerHelper.erstellePlatzhalter(
                this.auftrag,
                MyApp.current.fahrer.getValue(),
                MyApp.current.fahrzeug.getValue(),
                null);

            if (text.includes('{GPS}')) {
                platzhalter['GPS'] = await SystemService.instance.getAktuelleGpsPositionStr('Bild', 10);
            }

            let pictureFilePaths: string[] = await CameraHelper.pickPicturesFromLibrary({
                filenamePrefix: 'auftrag-' + this.auftrag.Auftragsnummer,
                textPlatzhalter: platzhalter,
                text: text,
            });

            if (pictureFilePaths?.length) {
                for (const filePath of pictureFilePaths) {
                    log?.debug('pictureSrc', filePath);

                    const bild: ReCoMobilBild = {
                        Datum: new Date().toISOString(),
                        // Bild: imageData,
                        BildGuid: Utils.uuid()
                    };

                    await AuftragService.instance.speichereBild(bild.BildGuid, filePath);

                    if (!this.auftrag.Auftragsbilder) {
                        this.auftrag.Auftragsbilder = [];
                    }

                    this.auftrag.Auftragsbilder.push(bild);

                    await AuftragService.instance.speichereAuftrag(this.auftrag);

                    this.auftragsbilder.push(await this.createBildVo(bild));
                }

                await this.starteAuftragWennErforderlich('onFotoAufnehmen');

                this.detectChanges.next('onFotoAufnehmen');
            }

            setTimeout(() => {
                this.kameraAktiv = false;
            }, 250);
        } catch (err) {
            log.error('Fehler beim Auswählen von Bildern: ' + Utils.getErrorMessage(err), err);
        } finally {
            MyApp.loading(false);
        }

        // setTimeout(() => this.content.scrollToBottom(300), 250);
    }

    /**
     * Gibt an, ob nach einer Foto-Aufnahme im Auftrag ein Kommentar erfasst werden kann.
     * Wird über die Einstellung FotosKommentarAuftrag gesteuert (standardmäßig aus).
     */
    get istBildKommentarAktiv(): boolean {
        return AppConfig.current.einstellungen.FotosKommentarAuftrag === 'ja';
    }

    frageBildAktion(): Promise<string> {
        return new Promise(async resolve => {
            if (this.istAuftragAbgeschlossen) {
                // Keine Buttons notwendig. Bild kann nur angezeigt werden
                resolve('anzeigen');
                return;
            }

            const buttons: any[] = [];

            buttons.push({
                text: 'Löschen',
                role: 'destructive',
                icon: 'trash',
                handler: () => {
                    resolve('loeschen');
                }
            });

            buttons.push({
                text: 'Anzeigen',
                icon: 'image',
                handler: () => {
                    resolve('anzeigen');
                }
            });

            if (this.istBildKommentarAktiv) {
                buttons.push({
                    text: 'Kommentar',
                    icon: 'chatbubble-ellipses',
                    handler: () => {
                        resolve('kommentar');
                    }
                });
            }

            buttons.push({
                text: 'Abbruch',
                icon: 'close',
                role: 'cancel',
                handler: () => {
                    resolve(null);
                }
            });

            const alert = await this.alertController.create({
                cssClass: 'no-text-alert no-title-alert',
                mode: 'ios',
                buttons: buttons
            });

            await alert.present();
        });
    }

    async onBildClicked(vo: BildVO) {
        const aktion = await this.frageBildAktion();

        if (aktion === 'loeschen') {
            const ok = true; //  await UiHelper.confirmJaNein('', 'Bild wirklich löschen?');

            if (ok) {
                const idx = this.auftrag.Auftragsbilder.findIndex(p => p.BildGuid === vo.guid);

                if (idx > -1) {
                    const guid = vo.guid;

                    this.auftrag.Auftragsbilder.splice(idx, 1);

                    await AuftragService.instance.speichereAuftrag(this.auftrag);

                    const idx2 = this.auftragsbilder.findIndex(p => p.guid === vo.guid);

                    if (idx2 > -1) {
                        this.auftragsbilder.splice(idx2, 1);
                    }

                    this.detectChanges.next('doBildClicked');

                    await AuftragService.instance.loescheBild(guid);
                }
            }
        } else if (aktion === 'anzeigen') {
            this.doBildAnzeigen(vo);
        } else if (aktion === 'kommentar') {
            await this.bearbeiteBildKommentar(vo);
        }
    }

    /**
     * Fragt einen Kommentar zum Bild ab und speichert ihn im Feld Bezeichnung des Bildes.
     * Verwendet denselben Alert-Dialog wie die Namenseingabe bei der Unterschrift.
     * Der Kommentar wird zusammen mit dem Auftrag an den Server übertragen.
     *
     * @param bild Optional das zugehörige ReCoMobilBild. Wird sonst über die Guid ermittelt.
     * @param speichern Wenn true, wird der Auftrag direkt gespeichert. Beim Aufruf aus der
     *                  Foto-Aufnahme wird dies übersprungen, da dort ohnehin gespeichert wird.
     */
    async bearbeiteBildKommentar(vo: BildVO, bild?: ReCoMobilBild, speichern = true): Promise<void> {
        if (!bild) {
            bild = this.auftrag.Auftragsbilder?.find(p => p.BildGuid === vo.guid);
        }

        if (!bild) {
            return;
        }

        const alert = await this.alertController.create({
            cssClass: 'input-alert',
            message: 'Kommentar zum Bild',
            inputs: [
                {
                    name: 'kommentar',
                    type: 'textarea',
                    attributes: {
                        rows: 2
                    },
                    placeholder: '',
                    value: bild.Bezeichnung ?? ''
                }
            ],
            buttons: [
                {
                    text: 'Abbruch',
                    role: 'cancel'
                },
                {
                    text: 'OK',
                    role: 'accept',
                    handler: async data => {
                        const kommentar = (data.kommentar ?? '').trim();

                        bild.Bezeichnung = kommentar;
                        vo.bezeichnung = kommentar;

                        if (speichern) {
                            await AuftragService.instance.speichereAuftrag(this.auftrag);
                        }

                        this.detectChanges.next('bearbeiteBildKommentar');
                    }
                }
            ]
        });

        await alert.present();

        const firstInput: any = document.querySelector('ion-alert textarea, ion-alert input');

        if (firstInput) {
            firstInput.focus();
        }

        await alert.onWillDismiss();
    }

    async doBildAnzeigen(vo: BildVO) {
        if (!MyApp.isCordovaAvailable()) {
            UiHelper.showAlert('Bild anzeigen in Simulation nicht verfügbar', 'Simulation');
            return;
        }

        const filePath = await AuftragService.instance.getBildSrc(vo.guid);
        await this.fileOpener.open(filePath, 'image/jpeg');
    }

    /**
     * Zeigt die Seite / Popup zum Änderung der Lieferung an.
     * Es werden alle Positionen in einer Liste angezeigt.
     */
    async lieferungAendern() {
        log?.debug('lieferungAendern: ' + this.auftrag.Key);

        const modal = await this.modalController.create({
            component: AuftragLieferungPage,
            // cssClass: 'modal-fullscreen',
            componentProps: {
                'auftrag': this.auftrag,
                'auftragdetails': this
            }
        });

        log?.debug('lieferungAendern: AuftragLieferungPage wird angezeigt...');
        await modal.present();

        await modal.onDidDismiss();

        log?.debug('lieferungAendern: geschlossen');

        await Utils.delay(250);

        if (!this.disposed) {
            this.updateLieferungVollstaendig('lieferungAendern');
            this.detectChanges.next('lieferungAendern');
        }
    }

    /**
     * Zeigt ein Popup zum Änderung der Auftragsposition an.
     * Wird verwendet wenn die Positionen einzeln bearbeitet werden sollen.
     */
    async auftragspositionAendern(auftragsposition: AuftragspositionEx) {
        log?.debug(`auftragspositionAendern: ${this.auftrag.Key}, ${auftragsposition.PosNr}`);

        const modal = await this.modalController.create({
            component: AuftragLieferungPage,
            // cssClass: 'modal-fullscreen',
            componentProps: {
                'auftrag': this.auftrag,
                'auftragsposition': auftragsposition,
                'auftragdetails': this
            }
        });

        log?.debug('lieferungAendern: AuftragLieferungPage wird angezeigt...');
        await modal.present();

        await modal.onDidDismiss();

        log?.debug('lieferungAendern: geschlossen');

        await Utils.delay(250);

        if (!this.disposed) {
            this.updateLieferungVollstaendig('lieferungAendern');
            this.detectChanges.next('lieferungAendern');
        }
    }

    async auftragspositionWiegen(auftragsposition: AuftragspositionEx): Promise<boolean> {
        log?.debug(`auftragspositionWiegen: ${this.auftrag.Key}, ${auftragsposition.PosNr}`);

        const modal = await this.modalController.create({
            component: AuftragspositionWiegenPopupPage,
            // cssClass: 'modal-fullscreen',
            componentProps: {
                'auftrag': this.auftrag,
                'auftragsposition': auftragsposition,
                'auftragdetails': this
            }
        });

        log?.debug('auftragspositionWiegen: AuftragspositionWiegenPopupPage wird angezeigt...');
        await modal.present();

        await modal.onDidDismiss();

        log?.debug('auftragspositionWiegen: geschlossen');

        await Utils.delay(250);

        if (!this.disposed) {
            this.updateLieferungVollstaendig('auftragspositionWiegen');
            this.detectChanges.next('auftragspositionWiegen');
        }

        return true;
    }

    /**
     * Berechnet die Mengen aus den Wiegungen.
     * Wird nach dem Empfang von Wiegedaten aufgerufen.
     */
    berechneMengeAusWiegungen(auftragsposition: AuftragspositionEx) {
        if (!auftragsposition.Wiegungen) {
            auftragsposition.Wiegungen = [];
        }

        let summeNetto = 0;

        for (const w of auftragsposition.Wiegungen) {
            if (w.Netto) {
                summeNetto += Utils.parseFloat(w.Netto);
            }
        }

        summeNetto = Utils.round(summeNetto, 1);

        auftragsposition.GewichtInKg = summeNetto;

        let einheit = auftragsposition.Einheit;

        if (einheit) {
            einheit = einheit.trim().toLowerCase();

            if (einheit == 'kg') {
                auftragsposition.Menge = summeNetto;

                // Sonderfall Mandant OFK 
                // Welvaarts + Wiegung durch App:
                // Eine Nullwiegung (Netto 0) soll automatisch 5 kg als Menge ergeben (nur Kg-Artikel) -> Mindestgewicht der Waage bei Durchführung einer Wiegung
                // Muss hier stehen damit der Wert einen erneuten
                // Aufruf (z.B. nach Schließen der Wiegung) übersteht und nicht wieder auf 0 zurückfällt.
                // Vorher war es bei der Wiegung selbst, aber dann wurde es wieder auf 0 gesetzt, wenn die Wiegung geschlossen wurde.
                if (summeNetto === 0
                    && auftragsposition.Wiegungen.length > 0
                    && getWaageModusInfo().wiegenDurchApp
                    && WaageService.instance?.getAktiveWaageKonfigurationen().some(k => k.typ === 'welvaarts')) {
                    
                    // hart enthalten, damit man sich Parameter spart und die Konfiguration nur bei OFK der Fall ist
                    auftragsposition.Menge = 5;
                }
            } else if (einheit == 'to' || einheit == 't') {
                auftragsposition.Menge = Utils.round(summeNetto / 1000, 3);
            }
        }
    }

    async leergutAendern() {
        log?.debug('leergutAendern: ' + this.auftrag.Key);

        const modal = await this.modalController.create({
            component: AuftragLieferungPage,
            // cssClass: 'modal-fullscreen',
            componentProps: {
                'auftrag': this.auftrag,
                'auftragdetails': this
            }
        });

        log?.debug('leergutAendern: AuftragLieferungPage wird angezeigt...');
        await modal.present();

        await modal.onDidDismiss();

        log?.debug('leergutAendern: geschlossen');

        await Utils.delay(250);

        if (!this.disposed) {
            this.updateLeergutVollstaendig('leergutAendern');
            this.detectChanges.next('leergutAendern');
        }
    }

    async anzeigenBarcode() {
        const modal = await this.modalController.create({
            component: AuftragBarcodeModalPage,
            componentProps: {
                'auftrag': this.auftrag
            }
        });

        await modal.present();

        await modal.onDidDismiss();
    }

    async anzeigenAnmerkungen() {
        log?.debug('anzeigenAnmerkungen: ' + this.auftrag.Key);

        if (this.isAnmerkungenErfassenGesperrt) {
            return;
        }

        if (!await this.pruefeZeiterfassungGestartet()) {
            return;
        }

        this.updateAuftragAbgeschlossen();

        if (this.istAuftragAbgeschlossen) {
            return;
        }

        const modal = await this.modalController.create({
            component: AuftragAnmerkungenPage,
            componentProps: {
                'auftrag': this.auftrag
            }
        });

        await modal.present();

        await modal.onWillDismiss();

        if (this.auftrag.Anmerkungen) {
            log?.debug('Anmerkungen: ' + this.auftrag.Anmerkungen);

            // Anmerkungen wurden eingegeben.
            await this.starteAuftragWennErforderlich('Anmerkungen');
        }

        this.detectChanges.next('anzeigenAnmerkungen');
    }

    async starteAuftragWennErforderlich(info: string): Promise<void> {
        try {
            if (AppConfig.current.einstellungen.AuftragStartenBeiAenderung === 'ja') {
                if (this.auftrag.Auftragsstatus < Auftragsstatus.InBearbeitung) {
                    if (this.isAuftragReadOnly()) {
                        return;
                    }

                    log?.debug(`Starte Auftrag ${this.auftrag.Key}: ${info}`);

                    // alert('starte auftrag: ' + this.auftrag.Auftragsstatus);

                    await this.auftragService.statusmeldung(this.auftrag, {
                        name: 'Auftrag start',
                        key: '0',
                        auftragsstatus: Auftragsstatus.InBearbeitung,
                    });

                    log?.debug(`Starte Auftrag ${this.auftrag.Key}: neuer Auftragsstatus ${this.auftrag.Auftragsstatus}`);
                }
            }
        } catch (err) {
            log.error('starteAuftragWennErforderlich: ' + Utils.getErrorMessage(err));
        }
    }

    updateAuftragReadOnly() {
        this.isReadOnly = this.isAuftragReadOnly();

        const oldLieferungAendernGesperrt = this.isLieferungAendernGesperrt;

        // Wenn der ganze Auftrag schreibgeschützt ist (weil Tour nicht gestartet o.ä.), dann sind auch alle Einzelaktionen gesperrt
        this.isLieferungAendernGesperrt = this.isReadOnly;
        this.isBilderErfassenGesperrt = this.isReadOnly;
        this.isAnmerkungenErfassenGesperrt = this.isReadOnly;
        this.isStatusmeldungGesperrt = this.isReadOnly;
        this.isSchreibgeschuetztAnzeigen = this.isReadOnly;
        this.isNavigationGesperrt = this.isReadOnly;
        this.isUnterschreibenGesperrt = this.isReadOnly;

        if (this.workflow?.einstellungen.AuftragSchreibschutzNachUnterschrift === 'schreibgeschuetzt') {
            // Prüfe ob schon mindestens einer unterschrieben hat.
            const unterschrift = this.auftrag.Unterschriften?.find(p => !!p.Bild);

            if (unterschrift) {
                this.isLieferungAendernGesperrt = true;
            }
        }

        // Zusätzlich können auch einzelne Aktionen, wie z.B. die Navigation gesperrt sein, damit man den Auftrag erst annehmen muss.
        if (Utils.isTrue(this.workflow?.einstellungen.SchreibgeschuetztVorStatusmeldung) && !this.isReadOnly) {
            if (!this.auftrag?.statusmeldungen?.length) {
                // Es wurden noch keine Statusmeldungen gemacht
                // this.isSchreibgeschuetztAnzeigen = true;
                this.isNavigationGesperrt = true;
                this.isLieferungAendernGesperrt = true;
                this.isBilderErfassenGesperrt = true;
                this.isAnmerkungenErfassenGesperrt = true;
            }
        }

        // Navigation ist nur gesperrt, wenn es explizit so konfiguriert ist
        if (!Utils.isFalse(this.workflow?.einstellungen.NavigationErlaubenWennSchreibgeschuetzt)) {
            this.isNavigationGesperrt = false;
        }

        if (AppConfig.current.einstellungen.AuftragZeiterfassungAktiv === 'ja') {
            if (!this.auftrag.zeiterfassungLaeuft) {
                this.isLieferungAendernGesperrt = true;
            }
        }

        if (oldLieferungAendernGesperrt !== this.isLieferungAendernGesperrt) {
            this.isLieferungAendernGesperrtChanged.next(this.isLieferungAendernGesperrt);
        }
    }

    private isAuftragReadOnly(): boolean {
        this.schreibschutzGrund = '';

        if (!this.auftrag) {
            return false;
        }

        if (this.auftrag.Auftragsstatus >= Auftragsstatus.Abgeschlossen) {
            log?.debug('Auftrag ist ReadOnly, weil Auftragsstatus >= 90: ' + this.auftrag.Auftragsstatus);
            this.schreibschutzGrund = 'Auftrag ist bereits abgeschlossen'; //TODO: Übersetzung
            return true;
        }

        const app = MyApp.current;

        if (this.auftrag.Auftragstyp === Auftragstyp.Transportauftrag) {
            if (app.tourStartenErforderlich.getValue()) {
                if (!app.tourGestartet.getValue()) {
                    log?.debug('Auftrag ist ReadOnly, weil Tour nicht gestartet');
                    this.schreibschutzGrund = 'Tour wurde noch nicht gestartet'; //TODO: Übersetzung
                    return true;
                }
            }

            const maxAnzahlSichtbareAuftraege = Utils.parseInt(AppConfig.current.einstellungen.TransportauftragMaxSichtbareAuftraege);

            if (maxAnzahlSichtbareAuftraege > 0) {
                // Anzahl sichtbare Aufträge ist eingeschränkt.
                // Prüfe ob der Auftrag derzeit eigentlich nicht sichtbar ist.
                // Wenn ja, dann ist er readOnly
                const alleAuftraege = this.auftragService.alleAuftraege;

                if (alleAuftraege) {
                    const aktuelleTransportauftraege = this.auftragService.filterAktuelleAuftraege(alleAuftraege, Auftragstyp.Transportauftrag);

                    AuftragHelper.sortiereAuftraege(aktuelleTransportauftraege);

                    const index = aktuelleTransportauftraege.findIndex(p => p.Key === this.auftrag.Key);

                    if (index >= maxAnzahlSichtbareAuftraege) {
                        log?.debug('Auftrag ist ReadOnly, weil noch nicht an der Reihe');
                        this.schreibschutzGrund = 'Auftrag ist noch nicht an der Reihe'; //TODO: Übersetzung
                        return true;
                    }
                }
            }

            // Standardmäßig auf aus setzen, damit der Parameter nicht aktiviert ist
            if (AppConfig.current.einstellungen.TransportauftragBearbeitbarRegel === 'nur-heute') {
                const heute = moment().endOf('day');
                const abholdatum = Utils.parseDatum(this.auftrag.AAbholdatum);

                if (abholdatum.isAfter(heute, 'day')) {
                    log?.debug('Auftrag ist ReadOnly, weil erst ab einem bestimmten Datum änderbar');
                    this.schreibschutzGrund = 'Auftrag ist erst ab dem Abholdatum bearbeitbar'; //TODO: Übersetzung
                    return true;
                }
            }

            // Für Herzog nur Aufträge bearbeiten lassen, die auch das Fahrzeug der Tour haben
            if (AppConfig.current.einstellungen.TransportauftragBearbeitbarRegel === 'aktivesFahrzeug') {
                const aktuelleTour = app.aktuelleTour.getValue();

                if (aktuelleTour && aktuelleTour.Fahrzeug) {
                    const tourFahrzeug = Utils.trimToEmpty(aktuelleTour.Fahrzeug).toUpperCase();
                    const auftragFahrzeuge = [
                        this.auftrag.FahrzeugKennung,
                        this.auftrag.FahrzeugKennung2,
                        this.auftrag.FahrzeugKennung3
                    ];

                    let ok = auftragFahrzeuge.some(p => p && Utils.trimToEmpty(p).toUpperCase() == tourFahrzeug);

                    if (!ok) {
                        log?.debug(`Auftrag ist ReadOnly, weil nur mit dem richtigen Fahrzeug änderbar. Soll=${tourFahrzeug}, Ist=${auftragFahrzeuge[0]}`);
                        this.schreibschutzGrund = 'Auftrag kann nur mit dem passenden Fahrzeug bearbeitet werden'; //TODO: Übersetzung
                        return true;
                    }
                }
            }
        }

        // Standard: nicht readonly
        return false;
    }

    /**
     * Aktualisiert, welche Ansicht für den neutralen Workflow angezeigt werden soll (Natura).
     * Sollte nur beim Öffnen des Auftrags aufgerufen werden.
     * Der Fahrer soll die Ansicht selbstständig bei Bedarf ändern können. Dann darf diese Methode nicht mehr aufgerufen werden.
     */
    updateNeutralAktuelleAnsicht() {
        if (this.workflow?.einstellungen?.Neutral === 'ja') {
            let isAbholstelleFertig = false;

            this.neutralAktuelleAnsicht = NeutralWorkflowAktuelleAnsichtTyp.Erzeuger;

            const unterschriftKunde = this.auftrag.Unterschriften?.find(p => p.Typ === 'ERZ');

            if (unterschriftKunde?.Bild) {
                // Unterschrift vom Erzeuger ist vorhanden. Wir fahren jetzt also zum Entsorger.
                isAbholstelleFertig = true;
            } else {
                if (this.auftrag.statusmeldungen?.length && this.auftrag.statusmeldungen.find(p => p.abholstelleFertig)) {
                    // Der Fahrer hat eine Statusmeldung gemacht, dass er am Einsatzort fertig ist.
                    // => er fährt also jetzt zum Entsorger.
                    isAbholstelleFertig = true;
                }
            }

            if (isAbholstelleFertig) {
                this.neutralAktuelleAnsicht = NeutralWorkflowAktuelleAnsichtTyp.Entsorger;
            } else {
                this.neutralAktuelleAnsicht = NeutralWorkflowAktuelleAnsichtTyp.Erzeuger;
            }
        } else {
            this.neutralAktuelleAnsicht = NeutralWorkflowAktuelleAnsichtTyp.Unbekannt;
        }
    }

    updateHandeingabeErlaubt() {
        // if (this.auftrag?.Zusatzdaten?.HandeingabeAktiviert === 'ja') {
        //     this.isHandeingabeErlaubt = true;
        // } else {
        //     this.isHandeingabeErlaubt = false;
        // }
    }

    async seriennummernBearbeiten(position: AuftragspositionEx) {
        log?.debug('seriennummernBearbeiten: ' + this.auftrag.Key + ', ' + position.PosNr);

        const modal = await this.modalController.create({
            component: SeriennummernListeComponent,
            componentProps: {
                'auftrag': this.auftrag,
                'position': position,
                'auftragdetails': this
            }
        });

        await modal.present();

        await modal.onDidDismiss();

        this.detectChanges.next('seriennummernBearbeiten');
    }

    async druckenAuftragsposition(position: AuftragspositionEx, sofortDrucken = true) {
        log?.debug('druckenAuftragsposition: ' + this.auftrag.Key + ', ' + position.PosNr);

        // TODO: Abhängig machen vom Auftragstyp
        const druckformularName = 'Wareneingang';

        // const workflowStatus = this.workflow.status.find(p => p.auftragsstatus == Auftragsstatus.Gedruckt);

        // if (!workflowStatus) {
        //     UiHelper.showErrorOhneSentry('Drucken-Status nicht gefunden');
        //     return;
        // }

        const modal = await this.modalController.create({
            component: AuftragDruckenPage,
            componentProps: {
                'auftrag': this.auftrag,
                'position': position,
                'auftragdetails': this,
                'workflowStatus': null,
                'druckformularName': druckformularName,
                'sofortDrucken': sofortDrucken,
            }
        });

        await modal.present();

        await modal.onDidDismiss();

        this.detectChanges.next('druckenAuftragsposition');
    }

    async drucken(druckformularName: string) {
        log?.debug('drucken: ' + this.auftrag.Key + ', ' + druckformularName);

        const workflowStatus = this.workflow.status.find(p => p.auftragsstatus == Auftragsstatus.Gedruckt);

        if (!workflowStatus) {
            UiHelper.showErrorOhneSentry('Drucken-Status nicht gefunden');
            return;
        }

        const modal = await this.modalController.create({
            component: AuftragDruckenPage,
            componentProps: {
                'auftrag': this.auftrag,
                'auftragdetails': this,
                'workflowStatus': workflowStatus,
                'druckformularName': druckformularName,
                'sofortDrucken': true
            }
        });

        await modal.present();

        await modal.onDidDismiss();

        this.detectChanges.next('anzeigenDrucken');
    }

    async anzeigenDrucken(workflowStatus: WorkflowStatus) {
        log?.debug('anzeigenDrucken: ' + this.auftrag.Key);

        const modal = await this.modalController.create({
            component: AuftragDruckenPage,
            componentProps: {
                'auftrag': this.auftrag,
                'auftragdetails': this,
                'workflowStatus': workflowStatus
            }
        });

        await modal.present();

        await modal.onDidDismiss();

        this.detectChanges.next('anzeigenDrucken');
    }

    /**
     * Pflichtdruck beim Abschließen: "Druck auf App aktiv" an einer Adresse oder "Druck aktiv" am Artikel (ReCoLog).
     * Ist der Auftrag noch nicht gedruckt, muss der Fahrer drucken oder ausdrücklich ohne Druck abschließen.
     */
    private async pruefePflichtdruck(status: WorkflowStatus): Promise<PflichtdruckErgebnis> {
        const ergebnis: PflichtdruckErgebnis = {
            abbruch: false,
            dialogAngezeigt: false,
            uebersprungenGrund: null
        };

        if (!AuftragHelper.istPflichtdruckErforderlich(this.auftrag) || AuftragHelper.istAuftragGedruckt(this.auftrag, this.workflow)) {
            return ergebnis;
        }

        log?.info('Pflichtdruck: Auftrag wurde noch nicht gedruckt: ' + this.auftrag.Key);

        ergebnis.dialogAngezeigt = true;

        // confirmButtons liefert die Beschriftung zurück, deshalb die übersetzten Texte vergleichen
        const DRUCKEN = I18N.instant('Drucken');
        const ERNEUT_VERSUCHEN = I18N.instant('Erneut versuchen');
        const OHNE_DRUCK = I18N.instant('Ohne Druck abschließen');
        const ABBRECHEN = I18N.instant('Abbrechen');
        const ZURUECK = I18N.instant('Zurück');

        // Fehler des letzten Druckversuchs. NULL, solange nicht gedruckt oder der Druck-Dialog nur geschlossen wurde
        let fehler: string = null;

        while (true) {
            let auswahl: string;

            if (fehler) {
                // Der DruckerService zeigt seine Fehlermeldung selbst an. Die Auswahl kommt erst danach
                await this.warteAufOffeneFehlermeldung();

                auswahl = await UiHelper.confirmButtons(`${I18N.instant('Druck nicht möglich')}: ${fehler}`, I18N.instant('Druck fehlgeschlagen'), [ERNEUT_VERSUCHEN, OHNE_DRUCK, ABBRECHEN]);

                if (auswahl === OHNE_DRUCK) {
                    // Ohne zweite Sicherheitsabfrage, der Grund ist bekannt
                    ergebnis.uebersprungenGrund = 'Druckfehler: ' + fehler;
                    return ergebnis;
                }
            } else {
                auswahl = await UiHelper.confirmButtons(I18N.instant('Für diesen Auftrag ist ein Ausdruck vorgeschrieben. Der Auftrag wurde noch nicht gedruckt.'), I18N.instant('Druck erforderlich'), [DRUCKEN, OHNE_DRUCK, ABBRECHEN]);

                if (auswahl === OHNE_DRUCK) {
                    const bestaetigung = await UiHelper.confirmButtons(I18N.instant('Auftrag wirklich ohne Ausdruck abschließen?'), OHNE_DRUCK, [OHNE_DRUCK, ZURUECK]);

                    if (bestaetigung === OHNE_DRUCK) {
                        ergebnis.uebersprungenGrund = 'vom Fahrer übersprungen';
                        return ergebnis;
                    }

                    continue;
                }
            }

            if (auswahl !== DRUCKEN && auswahl !== ERNEUT_VERSUCHEN) {
                // Abbrechen oder Dialog geschlossen
                ergebnis.abbruch = true;
                return ergebnis;
            }

            const druck = await this.druckenFuerPflichtdruck(status);

            if (druck.gedruckt) {
                return ergebnis;
            }

            fehler = druck.fehler;
        }
    }

    /**
     * Öffnet den Druck-Dialog. Der Fahrer wählt Drucker, Formular und Anzahl selbst und druckt.
     * Vorbelegt ist das Formular aus "Auto. Druck" des Status, sonst wie beim manuellen Druck.
     * Gemeldet wird der Druck mit dem Druck-Status des Workflows.
     */
    private async druckenFuerPflichtdruck(status: WorkflowStatus): Promise<PflichtdruckDruckErgebnis> {
        const druckStatus = this.workflow?.status?.find(p => p.auftragsstatus == Auftragsstatus.Gedruckt) ?? null;

        const modal = await this.modalController.create({
            component: AuftragDruckenPage,
            componentProps: {
                'auftrag': this.auftrag,
                'auftragdetails': this,
                'workflowStatus': druckStatus,
                'druckformularName': status.AutoDruckDruckformular || '',
                'pflichtdruck': true
            }
        });

        await modal.present();

        const result = await modal.onDidDismiss();

        this.detectChanges.next('druckenFuerPflichtdruck');

        return {
            gedruckt: result.data?.gedruckt === true,
            fehler: result.data?.fehler || null
        };
    }

    /**
     * Wartet, bis eine noch offene Fehlermeldung (z.B. vom DruckerService) geschlossen wurde,
     * damit der nächste Dialog nicht darüber liegt.
     */
    private async warteAufOffeneFehlermeldung(): Promise<void> {
        // Der DruckerService öffnet seine Meldung ohne await
        await Utils.delay(300);

        if (UiHelper.errorAlert) {
            await UiHelper.errorAlert.onDidDismiss();
        }
    }

    async anzeigenBezahlen(workflowStatus: WorkflowStatus) {
        log?.debug('anmerkungenAnzeigen: ' + this.auftrag.Key);

        const modal = await this.modalController.create({
            component: AuftragBezahlenPage,
            componentProps: {
                'auftrag': this.auftrag,
                'auftragdetails': this,
                'workflowStatus': workflowStatus
            }
        });

        await modal.present();

        await modal.onDidDismiss();

        this.detectChanges.next('anzeigenBezahlen');
    }

    async anzeigenAdresseAendern(adresse: Adresse) {
        log?.debug('anzeigenAdresseAendern: ' + this.auftrag.Key);

        const modal = await this.modalController.create({
            component: AuftragAdressePage,
            componentProps: {
                'auftrag': this.auftrag,
                'auftragdetails': this,
                'adresse': adresse
            }
        });

        await modal.present();

        await modal.onDidDismiss();

        this.detectChanges.next('anzeigenAdresseAendern');
    }

    async anzeigenWeiterleiten(workflowStatus: WorkflowStatus) {
        log?.debug('anzeigenWeiterleiten: ' + this.auftrag.Key);

        const modal = await this.modalController.create({
            component: AuftragWeiterleitenPage,
            componentProps: {
                'auftrag': this.auftrag,
                'auftragdetails': this,
                'workflowStatus': workflowStatus
            }
        });

        await modal.present();

        const result = await modal.onDidDismiss();

        log?.debug('result', result);

        if (result.data?.weitergeleitet) {
            // Auftrag wurde erfolgreich weitergeleitet
            this.auftragAbgeschlossen.next('weiterleiten');
        }
    }

    async anzeigenStoerzeiten() {
        log?.debug('anzeigenStoerzeiten: ' + this.auftrag.Key);

        // TODO

        const modal = await this.modalController.create({
            component: StoerzeitenPage,
            componentProps: {
                'auftragdetails': this
            }
        });

        await modal.present();

        await modal.onDidDismiss();
    }

    updateLieferungVollstaendig(info: string) {
        const fehlertext = this.pruefeAuftragspositionenVollstaendig();

        log?.debug('updateLieferungVollstaendig ' + info + ': ' + fehlertext);

        // Bei ReadOnly-Ansicht keine Fehlermeldung anzeigen
        if (fehlertext && !this.isLieferungAendernGesperrt) {
            this.lieferungFehlertext.next(fehlertext);
            this.istLieferungVollstaendig.next(false);
        } else {
            this.lieferungFehlertext.next('');
            this.istLieferungVollstaendig.next(true);
        }
    }

    updateLeergutVollstaendig(info: string) {
        const fehlertext = this.pruefeLeergutVollstaendig();

        log?.debug('updateLeergutVollstaendig ' + info + ': ' + fehlertext);

        if (fehlertext) {
            this.leergutFehlertext.next(fehlertext);
            this.istLeergutVollstaendig.next(false);
        } else {
            this.leergutFehlertext.next('');
            this.istLeergutVollstaendig.next(true);
        }
    }

    async onStatusmeldung() {
        const buttons: any[] = [];
        const workflow = this.workflow;

        if (!workflow) {
            return;
        }

        // TODO: Eventuell entfernen, weil man einen Auftrag ablehnen können soll, ohne die Statusmeldung zu starten
        // if (!await this.pruefeZeiterfassungGestartet()) {
        //     return;
        // }

        // const aktuellerStatus = this.auftrag.Statusmeldung;
        let statusListe = workflow.status.sort((a, b) => a.sortierung - b.sortierung);

        if (this.istAuftragAbgeschlossen) {
            statusListe = workflow.status.filter(p => p.NachAbschlussErlaubt).sort((a, b) => a.sortierung - b.sortierung);

            if (!statusListe.length) {
                this.showAuftragArchiviert();
                return;
            }
        } else if (this.isReadOnly) {
            // this.showAuftragSchreibgeschuetzt();
            // return;
        }

        if (statusListe.length >= 5) {
            // Liste anzeigen damit gescrollt werden kann
            const modal = await this.modalController.create({
                component: AuftragStatusmeldungPage,
                componentProps: {
                    'auftragdetails': this,
                    'statusListe': statusListe
                }
            });

            await modal.present();

            const result = await modal.onDidDismiss();

            if (result.data?.workflowStatus) {
                this.statusMelden(result.data.workflowStatus, true);
            }

            return;
        }

        // Normale Auswahl anzeigen
        for (const status of statusListe) {
            let role = '';

            if (status.auftragsstatus === Auftragsstatus.Abgelehnt) {
                role = 'destructive';
            }

            buttons.push({
                text: status.name,
                icon: status.icon,
                role: role,
                handler: () => {
                    this.statusMelden(status, true);
                }
            });
        }

        buttons.push({
            text: I18N.instant('Abbrechen'),
            icon: 'close',
            role: 'cancel',
            handler: () => { }
        });

        const alert = await this.alertController.create({
            header: 'Statusmeldung',
            cssClass: 'no-text-alert statusmeldungen-alert', // no-text-alert  no-title-alert
            mode: 'ios',
            buttons: buttons
        });

        UiHelper.addBackButtonHandler(alert);

        await alert.present();
    }

    pruefeUnterschriftenVollstaendig(): string {
        const rollen = ['ERZ', 'BEF', 'ENT'];
        const erforderlicheUnterschriften: UnterschriftInfo[] = [];

        if (this.darstellung === 'wizard') {
            for (const wizardPage of this.workflow.WizardKonfiguration.WizardPages) {
                if (wizardPage.Aktiv === false) {
                    continue;
                }

                const unterschriftKomponente = wizardPage.Formular.komponenten.filter(p => p.name === 'Unterschrift');

                for (const komponente of unterschriftKomponente) {
                    for (const rolle of rollen) {
                        let wert = komponente.einstellungen.find(p => p.key === rolle)?.wert;

                        if (rolle === 'ERZ' && this.auftrag.UnterschriftKundeErforderlich) {
                            wert = 'ja';
                        }

                        if (wert === 'ja') {
                            const titel = komponente.einstellungen.find(p => p.key === rolle + '-Titel')?.wert;

                            erforderlicheUnterschriften.push({
                                rolle: rolle,
                                titel: titel
                            });
                        }
                    }
                }
            }
        } else {
            const komponente = this.formularKonfiguration.komponenten.find(p => p.name === 'Unterschrift');

            if (komponente) {
                for (const rolle of rollen) {
                    let wert = komponente.einstellungen.find(p => p.key === rolle)?.wert;

                    if (rolle === 'ERZ' && this.auftrag.UnterschriftKundeErforderlich) {
                        wert = 'ja';
                    }

                    if (wert === 'ja') {
                        const titel = komponente.einstellungen.find(p => p.key === rolle + '-Titel')?.wert;

                        erforderlicheUnterschriften.push({
                            rolle: rolle,
                            titel: titel
                        });
                    }
                }
            }
        }

        for (const item of erforderlicheUnterschriften) {
            const vorhanden = !!this.auftrag.Unterschriften.find(p => p.Typ === item.rolle)?.Guid;

            if (!vorhanden) {
                return `Unterschrift ${item.titel} (${item.rolle}) ist erforderlich`;
            }
        }

        return null;
    }

    onAuftragspositionFertigChanged(position: AuftragspositionEx) {
        this.auftragspositionFertigChanged.next(position);
    }

    updatePositionen() {
        log?.debug('updatePositionen');

        const artikelList = this.stammdatenService.getAlleArtikel().getValue();

        for (const position of this.auftrag.Positionen) {
            if (!position.Eigenschaften) {
                position.Eigenschaften = [];
            }

            const eigenschaftenUppercase = AppConfig.current.einstellungen.AlleEigenschaftenUppercase === 'ja';

            for (const eigenschaft of position.Eigenschaften) {
                if (!eigenschaft.Typ) {
                    eigenschaft.Typ = 'text';
                }

                if (eigenschaftenUppercase) {
                    eigenschaft.Uppercase = true;
                }
            }

            // Hier extra mit == prüfen. Kann Zahl oder String sein
            const artikel = artikelList.find(p => p.artikelKey == position.ArtikelKey as any);

            if (artikel) {
                // SeriennummerErforderlich
                switch (AppConfig.current.einstellungen.DatenherkunftSeriennummerErforderlich) {
                    case 'auftrag':
                        // Keine Änderung
                        break;

                    case 'artikel':
                        position.SeriennummerErforderlich = artikel.SeriennummerErforderlich;
                        break;

                    default:
                        if (artikel.SeriennummerErforderlich) {
                            if (position.SeriennummerErforderlich === null || typeof (position.SeriennummerErforderlich) === 'undefined') {
                                position.SeriennummerErforderlich = artikel.SeriennummerErforderlich;
                            }
                        }
                        break;
                }

                if (this.auftrag.Auftragstyp === Auftragstyp.Kommissionierung) {
                    // Chargenpflicht kommt immer aus dem Artikel
                    // Derzeit nur für Kommissionierungs-Aufträge setzen.
                    // Wird sonst nirgends benötigt
                    position.Chargenpflicht = artikel.Chargenpflicht;
                }
            }
        }
    }

    setNeutralAktuelleAnsicht(ansichtTyp: NeutralWorkflowAktuelleAnsichtTyp) {
        this.neutralAktuelleAnsicht = ansichtTyp;
        this.neutralAktuelleGeaendert.next();
        this.detectChanges.next('setNeutralAktuelleAnsicht');
    }

    /**
     * Gibt den "Status" zurück ob für Energore (BOSCHE-Ablauf) alle Wiegungen vollständig zugeordnet wurden.
     */
    getWiegungenZuordnenStatusObj(): WiegungenZuordnenStatusObj {
        if (!this.auftrag?.Positionen || !MyApp.current.waageVerfuegbar.getValue()) {
            return {
                status: 'nicht-erforderlich',
                differenz: 0,
                istAnzahl: 0,
                sollAnzahl: 0
            };
        }

        let result: WiegungenZuordnenStatusObj = {
            status: 'nicht-erforderlich',
            differenz: 0,
            istAnzahl: 0,
            sollAnzahl: 0
        };

        let sollAnzahl = 0;
        let istAnzahl = 0;

        for (const pos of this.auftrag.Positionen) {
            // Für Energor soll soll jede Tonne gewogen werden.
            // Deshalb muss es für jedes Stück eine eigene Wiegung geben.
            if (pos.Einheit === 'Stck' && pos.AuftragWiegungAktiv && pos.Menge > 0) {
                sollAnzahl += pos.Menge;
            }

            // Zähle die zugeordneten Wiegungen
            if (pos.Wiegungen?.length) {
                istAnzahl += pos.Wiegungen.length;
            }

            if (pos.Wiegungen2?.length) {
                istAnzahl += pos.Wiegungen2.length;
            }
        }

        if (sollAnzahl > 0) {
            if (istAnzahl === 0) {
                // Keine Wiegungen zugeordnet
                result.status = 'nicht-zugeordnet';
            } else if (sollAnzahl === istAnzahl) {
                // Alle Wiegungen zugeordnet
                result.status = 'vollstaendig';
            } else if (istAnzahl < sollAnzahl) {
                // Zu wenige Wiegungen zugeordnet
                result.status = 'teilweise-zugeordnet';
            } else {
                // Zu viele Wiegungen zugeordnet
                result.status = 'ueber-zugeordnet';
            }
        } else {
            // Der Auftrag erfordert keine Wiegungen
            result.status = 'nicht-erforderlich';
        }

        result.istAnzahl = istAnzahl;
        result.sollAnzahl = sollAnzahl;
        result.differenz = sollAnzahl - istAnzahl;

        return result;
    }

    async onPositionHinzufuegen(): Promise<boolean> {
        log?.debug('onPositionHinzufuegen: ' + this.auftrag.Key);

        if (this.isLieferungAendernGesperrt) {
            this.showAuftragSchreibgeschuetzt();
            return;
        }

        const modal = await this.modalController.create({
            component: AuftragArtikelAuswahlPage,
            componentProps: {
                'auftrag': this.auftrag
            }
        });

        log?.debug('AuftragArtikelAuswahlPage wird angezeigt...');
        await modal.present();

        const modalResult = await modal.onDidDismiss();

        log?.debug('AuftragArtikelAuswahlPage wurde geschlossen', modalResult);

        if (!modalResult) {
            // Abbruch
            return false;
        }

        const artikel = modalResult.data.artikel as Artikel;
        const vertrag = modalResult.data.vertrag as Vertrag;
        const vertragsposition = modalResult.data.vertragsposition as Vertragsposition;

        if (artikel) {
            const posNr = this.getNaechstePositionsnummer();

            let menge = 1;

            if (typeof (artikel.StandardMenge) == 'number') {
                menge = artikel.StandardMenge;
            }

            if (menge == 0 && artikel.einheit) {
                const einheit = artikel.einheit.toLowerCase();

                if (einheit == 'stk' || einheit == 'st' || einheit == 'pau') {
                    // Menge 0 macht bei Stück-Artikeln keinen Sinn
                    menge = 1;
                }
            }

            const position: Auftragsposition = {
                PosNr: posNr,
                ArtikelKey: artikel.artikelKey as any,
                Bezeichnung: artikel.bezeichnung,
                Bezeichnung2: artikel.Bezeichnung2,
                EinzelVK: artikel.einzelVK,
                MwstSatz: artikel.mwstSatz,
                BhAktion: artikel.BhAktion,
                IstNeu: true,
                IstGesendet: false,
                Eigenschaften: [],
                Menge: menge
            };

            position.MengeOption = artikel.MengeOption;
            position.StandardMenge = artikel.StandardMenge;

            // Wenn ein Artikel ausgewählt wurde soll geprüft werden ob ein Vertrag für diesen Artikel vorhanden ist.
            // Wenn ja, dann soll der Preis aus dem Vertrag verwendet werden (Beispiel: ZTN).
            let passendeVertragsposition: Vertragsposition = this.suchePassendeVertragspositionFuerArtikel(artikel);

            if (passendeVertragsposition) {
                // Es wurde eine Vertragsposition mit diesem Artikel gefunden.
                // => Verwende den Preis aus der Vertragsposition
                position.EinzelVK = passendeVertragsposition.EinzelVK;
                position.MwstSatz = passendeVertragsposition.MwstSatz;
            }

            position.SeriennummerErforderlich = artikel.SeriennummerErforderlich;
            position.AuftragWiegungAktiv = artikel.AuftragWiegungAktiv;
            position.LaderaumAuswahlAktiv = artikel.LaderaumAuswahlAktiv;

            this.auftrag.Positionen.push(position);

            this.aktualisierePositionsEigenschaften(position, artikel);

            this.updatePositionen();
        } else if (vertragsposition) {
            const posNr = this.getNaechstePositionsnummer();

            const position: Auftragsposition = {
                PosNr: posNr,
                ArtikelKey: vertragsposition.ArtikelKey,
                Bezeichnung: vertragsposition.Bezeichnung,
                IstNeu: true,
                IstGesendet: false,
                Eigenschaften: [],
                Menge: +vertragsposition.Menge,
                Vertragsposition: vertragsposition.PosNr,
                EinzelVK: vertragsposition.EinzelVK,
                MwstSatz: vertragsposition.MwstSatz,
                BhAktion: vertragsposition.BhAktion,
            };

            if (vertrag) {
                position.Vertragsnummer = vertrag.Vertragsnummer;
            }

            this.auftrag.Positionen.push(position);

            this.aktualisierePositionsEigenschaftenAusVertragsposition(position, vertragsposition);

            this.updatePositionen();
        }

        return true;
    }

    aktualisierePositionsEigenschaftenAusVertragsposition(position: Auftragsposition, vertragsposition: Vertragsposition): boolean {
        if (!vertragsposition.Eigenschaften) {
            return false;
        }

        let geaendert = false;

        if (!position.Eigenschaften) {
            position.Eigenschaften = [];
        }

        if (!position.Einheit) {
            position.Einheit = vertragsposition.Einheit;
        }

        if (position.GewichtInKgAktiv === null || typeof (position.GewichtInKgAktiv) === 'undefined') {
            position.GewichtInKgAktiv = vertragsposition.GewichtInKgAktiv;
        }

        if (position.GewichtInKgPflicht === null || typeof (position.GewichtInKgPflicht) === 'undefined') {
            position.GewichtInKgPflicht = vertragsposition.GewichtInKgPflicht;
        }

        if (!position.Bezeichnung) {
            position.Bezeichnung = vertragsposition.Bezeichnung;
        }

        for (const eigenschaft of position.Eigenschaften) {
            if (!eigenschaft.Typ) {
                const artikelEigenschaft = vertragsposition.Eigenschaften.find(p => p.Bezeichnung === eigenschaft.Bezeichnung);

                if (artikelEigenschaft) {
                    eigenschaft.Typ = artikelEigenschaft.Typ;
                    log?.debug('Typ aktualisiert: ' + eigenschaft.Typ, position);
                    geaendert = true;
                }
            }
        }

        // Fehlende Eigenschaften hinzufügen
        if (position.IstNeu) {
            for (const eigenschaft of vertragsposition.Eigenschaften) {
                const positionEigenschaft = position.Eigenschaften.find(p => p.Bezeichnung === eigenschaft.Bezeichnung);

                if (!positionEigenschaft) {
                    log?.debug('Eigenschaft zu position hinzufügen', { position, eigenschaft });

                    position.Eigenschaften.push({
                        Key: eigenschaft.Key,
                        Bezeichnung: eigenschaft.Bezeichnung,
                        Typ: eigenschaft.Typ,
                        Regex: eigenschaft.Regex,
                        Uppercase: eigenschaft.Uppercase,
                        Wert: '',
                        Sortierung: eigenschaft.Sortierung,
                        Sonderpruefung: eigenschaft.Sonderpruefung
                    });

                    geaendert = true;
                }
            }

            AuftragHelper.sortiereEigenschaften(position.Eigenschaften);
        }

        return geaendert;
    }

    suchePassendeVertragspositionFuerArtikel(artikel: Artikel): Vertragsposition {
        if (!this.auftrag.Vertraege?.length) {
            // Kein Vertrag vorhanden
            return null;
        }

        const strArtikelKey = artikel.artikelKey?.toString();

        for (const vertrag of this.auftrag.Vertraege) {
            if (!vertrag.Positionen) {
                continue;
            }

            for (const position of vertrag.Positionen) {
                if (position.ArtikelKey == strArtikelKey) {
                    // Passende Vertragspoisition gefunden. Verwende den Preis aus dieser Vertragsposition
                    return position;
                }
            }
        }

        return null;
    }

    aktualisierePositionsEigenschaften(position: AuftragspositionEx, artikel: Artikel): boolean {
        if (!artikel.eigenschaften) {
            return false;
        }

        let geaendert = false;

        if (!position.Eigenschaften) {
            position.Eigenschaften = [];
        }

        if (!position.Einheit) {
            position.Einheit = artikel.einheit;
        }

        // if (position.MengeOption === null || typeof (position.MengeOption) === 'undefined') {
        //     position.MengeOption = artikel.MengeOption;
        // }

        // if (position.StandardMenge === null || typeof (position.StandardMenge) === 'undefined') {
        //     position.StandardMenge = artikel.StandardMenge;
        // }

        // if (position.StandardMenge !== null && typeof (position.StandardMenge) !== 'undefined') {
        //     if (position.Menge === null || typeof (position.Menge) === 'undefined') {
        //         position.Menge = position.StandardMenge;
        //     }
        // }

        if (position.GewichtInKgAktiv === null || typeof (position.GewichtInKgAktiv) === 'undefined') {
            position.GewichtInKgAktiv = artikel.GewichtInKgAktiv;
        }

        if (position.GewichtInKgPflicht === null || typeof (position.GewichtInKgPflicht) === 'undefined') {
            position.GewichtInKgPflicht = artikel.GewichtInKgPflicht;
        }

        if (!position.Bezeichnung) {
            position.Bezeichnung = artikel.bezeichnung;
        }

        // Fehlende Eigenschaften hinzufügen
        if (position.IstNeu) {
            for (const eigenschaft of artikel.eigenschaften) {
                const positionEigenschaft = position.Eigenschaften.find(p => p.Bezeichnung === eigenschaft.bezeichnung);

                if (!positionEigenschaft) {
                    log?.debug('Eigenschaft zu position hinzufügen', { position, eigenschaft });

                    position.Eigenschaften.push({
                        Key: eigenschaft.key,
                        Bezeichnung: eigenschaft.bezeichnung,
                        Typ: eigenschaft.typ,
                        Regex: eigenschaft.Regex,
                        Uppercase: eigenschaft.Uppercase,
                        Wert: '',
                        Sortierung: eigenschaft.sortierung,
                        Sonderpruefung: eigenschaft.Sonderpruefung
                    });

                    geaendert = true;
                }
            }

            if (geaendert) {
                AuftragHelper.sortiereEigenschaften(position.Eigenschaften);
            }
        }

        // Wenn Artikel geändert wurde, Werte der gleichen Eigenschaften übernehmen
        if (position.ArtikelWurdeGeaendert) {   
            const alteEigenschaften = position.Eigenschaften ?? [];
            const neueEigenschaften = [];
            for (const artikelEigenschaft of artikel.eigenschaften) {

                const bestehend = alteEigenschaften.find(e => 
                    e.Bezeichnung === artikelEigenschaft.bezeichnung
                    // besser: e.Key === artikelEigenschaft.key
                );

                if (bestehend) {
                    // Wenn oldRegex / oldSonderpruefung gesetzt sind, ist die Pflicht gerade
                    // aufgehoben (z.B. Totgeburt bei OFK). Der Artikel-Regex darf sie dann nicht
                    // wieder aktivieren - sonst bleibt das Feld ausgeblendet und trotzdem pflichtig.
                    // Gleiche Absicherung wie weiter unten beim Abgleich mit den Stammdaten.
                    neueEigenschaften.push({
                        ...bestehend,
                        Typ: bestehend.Typ || artikelEigenschaft.typ,
                        Regex: bestehend.oldRegex
                            ? bestehend.Regex
                            : artikelEigenschaft.Regex ?? bestehend.Regex,
                        Uppercase: artikelEigenschaft.Uppercase ?? bestehend.Uppercase,
                        Sonderpruefung: bestehend.oldSonderpruefung
                            ? bestehend.Sonderpruefung
                            : artikelEigenschaft.Sonderpruefung ?? bestehend.Sonderpruefung
                    });
                } else {
                    // Noch nicht da, neu anlegen
                    neueEigenschaften.push({
                        Key: artikelEigenschaft.key,
                        Bezeichnung: artikelEigenschaft.bezeichnung,
                        Typ: artikelEigenschaft.typ,
                        Regex: artikelEigenschaft.Regex,
                        Uppercase: artikelEigenschaft.Uppercase,
                        Wert: '',
                        Sortierung: artikelEigenschaft.sortierung,
                        Sonderpruefung: artikelEigenschaft.Sonderpruefung
                    });
                }
            }
            position.Eigenschaften = neueEigenschaften;
            
            AuftragHelper.sortiereEigenschaften(position.Eigenschaften);
        }
        

        const allEigenschaftenUppercase = AppConfig.current.einstellungen.AlleEigenschaftenUppercase === 'ja';

        for (const eigenschaft of position.Eigenschaften) {
            const artikelEigenschaft = artikel.eigenschaften.find(p => p.bezeichnung === eigenschaft.Bezeichnung);

            if (artikelEigenschaft) {
                if (!eigenschaft.Typ) {
                    eigenschaft.Typ = artikelEigenschaft.typ;
                    log?.debug('Typ aktualisiert: ' + eigenschaft.Typ, position);
                    geaendert = true;
                }

                if (artikelEigenschaft.Regex && eigenschaft.Regex != artikelEigenschaft.Regex && !eigenschaft.oldRegex) {
                    eigenschaft.Regex = artikelEigenschaft.Regex;
                    log?.debug('Regex aktualisiert: ' + eigenschaft.Regex, position);
                    geaendert = true;
                }

                let uppercase = artikelEigenschaft.Uppercase;

                if (allEigenschaftenUppercase) {
                    uppercase = true;
                }

                if (uppercase != null && eigenschaft.Uppercase != uppercase) {
                    eigenschaft.Uppercase = uppercase;
                    log?.debug('Uppercase aktualisiert: ' + eigenschaft.Uppercase, position);
                    geaendert = true;
                }

                // Erstmal nur zum testen.
                if (artikelEigenschaft.Sonderpruefung && eigenschaft.Sonderpruefung != artikelEigenschaft.Sonderpruefung && !eigenschaft.oldSonderpruefung) {
                    eigenschaft.Sonderpruefung = artikelEigenschaft.Sonderpruefung;
                    log?.debug('Sonderpruefung aktualisiert: ' + eigenschaft.Sonderpruefung, position);
                    geaendert = true;
                }
            }
        }

        return geaendert;
    }

    /**
     * Darf der Fahrer die Position löschen? Steuert die Anzeige der Löschen-Buttons.
     *
     * Eigene, noch nicht gesendete Positionen dürfen immer gelöscht werden, ReCoLog kennt sie noch nicht.
     * Alle anderen nur mit der Einstellung "Positionen löschen erlaubt", denn ReCoLog löscht sie beim Import endgültig.
     * Ob die Position gerade gelöscht werden kann (Schreibschutz, letzte Position, Wiegungen), prüft erst loescheAuftragsposition().
     */
    istPositionLoeschbar(auftragsposition: AuftragspositionEx): boolean {
        if (auftragsposition.IstNeu && !auftragsposition.IstGesendet) {
            return true;
        }

        if (AppConfig.current.einstellungen.TransportauftragPositionLoeschenErlaubt !== 'ja') {
            return false;
        }

        if (this.auftrag.Auftragstyp !== Auftragstyp.Transportauftrag) {
            return false;
        }

        if (this.auftrag.IstNeuanlage) {
            // Bei Neuanlagen aus der App vergibt ReCoLog beim Import eigene Positionsnummern.
            // Eine schon gesendete Position ließe sich dort nicht sicher zuordnen.
            return false;
        }

        if (auftragsposition.BhAktion) {
            // Die Behälterbewegung (stellen, abziehen, ...) löscht ReCoLog mit der Position nicht mit
            return false;
        }

        return true;
    }

    /**
     * Löscht die Position nach Rückfrage. Gibt TRUE zurück, wenn gelöscht wurde.
     *
     * Eine eigene, noch nicht gesendete Position wird einfach entfernt.
     * Alle anderen wandern nach Auftrag.GeloeschtePositionen. Sie gehen mit jeder Statusmeldung mit Auftragsdaten
     * an ReCoLog, das sie dann löscht und in der Statusverfolgung vermerkt.
     */
    async loescheAuftragsposition(auftragsposition: AuftragspositionEx): Promise<boolean> {
        log.info('onPositionLoeschen: ' + this.auftrag.Auftragsnummer + ', Pos: ' + auftragsposition.PosNr);

        if (!this.istPositionLoeschbar(auftragsposition)) {
            return false;
        }

        if (this.isLieferungAendernGesperrt) {
            this.showAuftragSchreibgeschuetzt();
            return false;
        }

        const index = this.auftrag.Positionen.findIndex(p => p.PosNr === auftragsposition.PosNr);

        if (index < 0) {
            return false;
        }

        if (auftragsposition.IstNeu && !auftragsposition.IstGesendet) {
            const ok = await UiHelper.confirmJaNein(`Position ${auftragsposition.Bezeichnung} wirklich löschen?`, 'Löschen');

            if (!ok) {
                return false;
            }

            this.auftrag.Positionen.splice(index, 1);

            return true;
        }

        const sperrgrund = this.getPositionLoeschenSperrgrund(auftragsposition);

        if (sperrgrund) {
            await UiHelper.showAlert(sperrgrund, 'Löschen');
            return false;
        }

        const ok = await UiHelper.confirmJaNein(`Position ${auftragsposition.Bezeichnung} wirklich löschen? Sie wird auch im ERP-System endgültig gelöscht.`, 'Löschen');

        if (!ok) {
            return false;
        }

        this.auftrag.Positionen.splice(index, 1);

        auftragsposition.GeloeschtAm = Utils.nowIsoDateString();
        auftragsposition.GeloeschtVon = this.getPersonalText();

        if (!this.auftrag.GeloeschtePositionen) {
            this.auftrag.GeloeschtePositionen = [];
        }

        this.auftrag.GeloeschtePositionen.push(auftragsposition);

        log.info(`Position ${auftragsposition.PosNr} (APosId ${auftragsposition.APosId}) nach GeloeschtePositionen verschoben: ${this.auftrag.Key}`);

        await this.starteAuftragWennErforderlich('Position gelöscht');

        // Sofort speichern, nicht erst beim Verlassen der Seite: Die Löschung soll einen Absturz überstehen
        if (this.auftragService.istAktiverAuftrag(this.auftrag)) {
            await this.auftragService.speichereAuftrag(this.auftrag);
        }

        return true;
    }

    /**
     * Gibt zurück, warum eine Position, die ReCoLog bereits kennt, gerade nicht gelöscht werden kann (sonst null).
     */
    private getPositionLoeschenSperrgrund(auftragsposition: AuftragspositionEx): string {
        if (this.auftrag.Positionen.length <= 1) {
            // Ein Auftrag ohne Positionen ist in ReCoLog nicht vorgesehen
            return 'Die letzte Position kann nicht gelöscht werden.';
        }

        // Wiegungen2 enthält auch leere Platzhalter, es zählen nur erfasste Gewichte
        const hatWiegungen = auftragsposition.Wiegungen?.length > 0
            || auftragsposition.Wiegungen2?.some(p => p.Gewicht !== null && p.Gewicht !== undefined);

        if (hatWiegungen) {
            return 'Die Position hat Wiegungen. Bitte zuerst die Wiegungen entfernen.';
        }

        return null;
    }

    private getPersonalText(): string {
        const name = MyApp.current.getPersonalName();
        const personalnummer = MyApp.current.getPersonalnummer();

        return personalnummer ? `${name} (${personalnummer})` : name;
    }

    /**
     * Nächste freie PosNr für eine neue Position.
     * Gelöschte Positionen zählen mit: ReCoLog findet eine gelöschte neue Position über ihre PosNr (aAppPosition),
     * die Nummer darf deshalb nicht noch einmal vergeben werden.
     */
    private getNaechstePositionsnummer(): number {
        let posNr = 1;

        for (const p of [...this.auftrag.Positionen, ...(this.auftrag.GeloeschtePositionen ?? [])]) {
            if (p.PosNr >= posNr) {
                posNr = p.PosNr + 1;
            }
        }

        return posNr;
    }
}